import React, { useState, useRef, useEffect, useCallback } from "react";

import { Field, Form, Formik, useFormikContext } from "formik";

import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Grid,
  GridItem,
  SimpleGrid,
  Text,
  FormControl,
  FormLabel,
  Textarea,
  FormErrorMessage,
  Tooltip,
  Icon,
} from "@chakra-ui/react";

import * as Yup from "yup";
import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";
import { CustomSelectWField } from "../../../../components/CustomSelectWField";
import { CustomInputWField } from "../../../../components/CustomInputWField";
import CustomDropzone from "../../../../components/CustomDropzone";
import MovimentoService from "../../../../../main/services/MovimentoService";
import MotivoSituacaoService from "../../../../../main/services/MotivoSituacaoService";
import JustificativaService from "../../../../../main/services/JustificativaService";
import MovimentacaoService from "../../../../../main/services/MovimentacaoService";
import { FocusError } from "../../../../components/FocusError";
import CriancaService from "../../../../../main/services/CriancaService";
import { useHistory, useLocation } from "react-router";
import {
  addYears,
  differenceInYears,
  format,
  isAfter,
  isSameDay,
  isValid,
  parse,
} from "date-fns";
import pt from "date-fns/locale/pt";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import {
  criancaFunc,
  servicoAcolhimentoFunc,
} from "../../../../../helpers/Funcionalidades";
import { FamiliaAcolhedora } from "../../Cadastrar/FamiliaAcolhedora";
import ServicoAcolhimentoService from "../../../../../main/services/ServicoAcolhimentoService";
import Swal from "sweetalert2";
import FamiliaAcolhedoraSAService from "../../../../../main/services/FamiliaAcolhedoraSAService";
import ConfirmationModal from "../../Cadastrar/Movimentacao/ConfirmationModal";
import VisitasService from "../../../../../main/services/VisitasService";
import { mascaraNumeroGuia } from "../../../../utils/masks";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import { isValidCPF } from "../../../../utils/isValidCPF";
import { handleVerifyMovimento } from "../../../../utils/handleVerifyMovimento";
import { IoHelpCircle } from "react-icons/io5";
import FileInformation from "../../../../components/FileInformation";
const suportedFormats = [
  ".png",
  ".bmp",
  ".tiff",
  ".jpg",
  ".jpeg",
  ".doc",
  ".docx",
  ".txt",
  ".dot",
  ".pdf",
  ".xml",
  ".xls",
  ".xlam",
  ".ods",
];

export const CadastrarMovimentacaoModal = ({
  isOpen,
  data,
  onClose,
  idCrianca,
  setLoadingPainel,
  setLoadingHistorico,
  movimentoDefault,
  roleKeycloack,
  table,
  atualizarDados,
  dataNascimento,
  intercalada,
  setLoadingCadastro,
  fetchFunc,
  user,
  idPJ,
  handleGetCriancaReload,
  tableCrianca,
}) => {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idAnexoParam = searchParams.get("idAnexo");
  const idAba = searchParams.get("idAba");
  const [anexoGuiaEditado, setAnexoGuiaEditado] = useState();
  const [anexoGuiaEditadoTermoGuarda, setAnexoGuiaEditadoTermoGuarda] =
    useState();
  const gestor = roleKeycloack?.includes(criancaFunc.visualizarTudo);
  const ministerioPublico = roleKeycloack?.includes(
    servicoAcolhimentoFunc.visualizarParteMP
  );
  const tribunalJustica = roleKeycloack?.includes(
    servicoAcolhimentoFunc.visualizarParteTJ
  );

  const ppcaam = roleKeycloack?.includes(
    servicoAcolhimentoFunc.visualizarPartePPCAAM
  );

  const getGeneroLabel = (genero) => {
    return genero === "MASCULINO"
      ? { id: 1, label: "MASCULINO" }
      : genero === "FEMININO"
      ? { id: 2, label: "FEMININO" }
      : genero === "HOMEM TRANS"
      ? { id: 2, label: "HOMEM TRANS" }
      : genero === "MULHER TRANS"
      ? { id: 2, label: "MULHER TRANS" }
      : genero === "NÃO BINÁRIO"
      ? { id: 2, label: "NÃO BINÁRIO" }
      : genero === "TRAVESTI"
      ? { id: 2, label: "TRAVESTI" }
      : genero === "INTERSEXO"
      ? { id: 2, label: "INTERSEXO" }
      : "";
  };

  const [initialValues, setInitialValues] = useState({
    intercalada: intercalada ? intercalada : "",

    idServicoAcolhimento: "",
    idMovimento: "",
    existeNovaGuiaAcolhimento: "",
    idMotivoSituacao: "",
    incluidoProgramaPPCAAM: "",
    idJustificativa: "",
    informacoesComplementares: "",
    numeroGuia: "",
    dataMovimentacao: "",
    anexoGuia: null,

    idServicoAcolhimentoFinal: "",
    idMovimentoFinal: "",
    existeNovaGuiaAcolhimentoFinal: "",
    idMotivoSituacaoFinal: "",
    idJustificativaFinal: "",
    informacoesComplementaresFinal: "",
    numeroGuiaFinal: "",
    dataMovimentacaoFinal: "",
    anexoGuiaFinal: null,

    cpfFamiliaAcolhedora: "",
    nomeFamiliaAcolhedora: "",
    dataNascimentoFamiliaAcolhedora: "",
    idGeneroFamiliaAcolhedora: "",
    idBairroFamiliaAcolhedora: "",
    dataValidadeTermoGuarda: "",
    anexoTermoGuardaFamiliaAcolhedora: null,
  });

  const [dataFutura, setDataFutura] = useState(false);
  const [dataFuturaFinal, setDataFuturaFinal] = useState(false);
  const [dataNascimentoFuturaFamilia, setDataNascimentoFuturaFamilia] =
    useState();
  const [dataAnterior, setDataAnterior] = useState(false);
  const [dataPosterior, setDataPosterior] = useState(false);
  const [dataApadrinhamentoPosterior, setDataApadrinhamentoPosterior] =
    useState(false);
  const [mesmaFamilia, setMesmaFamilia] = useState(false);
  const [invalidCPF, setInvalidCPF] = useState(false);
  const [criancaCPFValid, setCriancaCPFValid] = useState(false);
  const [disabledMPTJ, setDisabledMPTJ] = useState(false);
  const [disabledPPCAAM, setDisabledPPCAAM] = useState(false);
  const [messageValid, setMessageValid] = useState("");
  const {
    ultimaMovimentacaoBuscar,
    movimentacaoData,
    movimentacaoDataAnterior,
    setMovimentacaoData,
    setMovimentacaoDataAnterior,
    movimentacaoDataPosterior,
    setMovimentacaoDataPosterior,
    setMovimentacaoEditar,
    movimentacaoEditar,
    movimentacaoIsFirst,
  } = useAppContext();

  useEffect(() => {
    const idOrgaoMovimentacao =
      movimentacaoData?.idOrgaoExterno || movimentacaoData?.idOrgao;

    const usuarioPossuiOrgaoExteno = user?.orgaoExterno?.includes(
      Number(idOrgaoMovimentacao)
    );
    const usuarioPossuiOrgao = user?.orgaos?.some(
      (orgao) => orgao.id === idOrgaoMovimentacao
    );

    const usuarioMPServicoPromotoria = user?.orgaos?.some(
      (orgao) =>
        orgao.id === movimentacaoData?.servicoAcolhimento?.promotoria?.id
    );

    const disabledMPServicoPromotoria =
      movimentacaoIsFirst && !usuarioMPServicoPromotoria;

    if (movimentacaoEditar) {
      setDisabledMPTJ(
        (movimentacaoEditar &&
          (ministerioPublico || tribunalJustica) &&
          !movimentacaoIsFirst) ||
          (((ministerioPublico && disabledMPServicoPromotoria) ||
            tribunalJustica) &&
            movimentacaoIsFirst &&
            !usuarioPossuiOrgao &&
            !usuarioPossuiOrgaoExteno)
      );

      setDisabledPPCAAM(movimentacaoEditar && ppcaam && movimentacaoIsFirst);
    }
  }, [
    ministerioPublico,
    movimentacaoData?.idOrgao,
    movimentacaoData?.idOrgaoExterno,
    tribunalJustica,
    user?.orgaoExterno,
    user?.orgaos,
    movimentacaoEditar,
    movimentacaoIsFirst,
    ppcaam,
    movimentacaoData?.servicoAcolhimento?.promotoria?.id,
  ]);

  const schemaMotivo = Yup.object().shape({
    idMovimento: Yup.object().nullable().required("Este campo é obrigatório"),
    idMovimentoFinal: Yup.object()
      .nullable()
      .when(["id"], {
        is: (id) => intercalada,
        then: Yup.object().required("Este campo é obrigatório"),
      }),

    existeNovaGuiaAcolhimento: Yup.object().when("idMovimento.id", {
      is: (idMovimentoId) => idMovimentoId === 1,
      then: Yup.object().nullable().required("Este campo é obrigatório!"),
      otherwise: Yup.object().nullable(),
    }),
    existeNovaGuiaAcolhimentoFinal: Yup.object().when(["idMovimentoFinal.id"], {
      is: (idMovimentoId) => idMovimentoId === 1 && intercalada,
      then: Yup.object().nullable().required("Este campo é obrigatório!"),
      otherwise: Yup.object().nullable(),
    }),
    numeroGuia: Yup.string().when(
      ["existeNovaGuiaAcolhimento.id", "anexoGuia", "originalAnexoGuia"],
      {
        is: (valueId, anexo, originalAnexoGuia) =>
          valueId === 1 || anexo || (originalAnexoGuia && !anexoGuiaEditado),
        then: Yup.string().required("Este campo é obrigatório!"),
        otherwise: Yup.string(),
      }
    ),
    numeroGuiaFinal: Yup.string().when(
      ["existeNovaGuiaAcolhimentoFinal.id", "anexoGuiaFinal"],
      {
        is: (valueId, anexo) => (valueId === 1 || anexo) && intercalada,
        then: Yup.string().required("Este campo é obrigatório!"),
        otherwise: Yup.string(),
      }
    ),

    anexoGuia: Yup.mixed()
      .nullable()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (!value) {
          return true;
        } else {
          return value?.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (
          value === null ||
          !value?.path ||
          typeof value?.path.toString !== "function"
        ) {
          return true;
        } else {
          const filePath = value?.path.toString().toLowerCase();

          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (filePath.includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),

    anexoGuiaFinal: Yup.mixed()
      .nullable()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (!value) {
          return true;
        } else {
          return value?.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (
          value === null ||
          !value?.path ||
          typeof value?.path.toString !== "function"
        ) {
          return true;
        } else {
          const filePath = value?.path.toString().toLowerCase();

          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (filePath.includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),

    dataMovimentacao: Yup.string()
      .nullable()
      .required("Este campo é obrigatório!")
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return false;
        }
      })
      .test(
        "dataNascimentoCompare",
        "A data do movimento, não pode ser menor que a data de nascimento.",
        function (value) {
          const dataMov = parse(value, "dd/MM/yyyy", new Date());
          const dataNasc = new Date(dataNascimento);

          if (!dataAnterior && isAfter(dataNasc, dataMov)) {
            return false;
          }
          return true;
        }
      )
      .test(
        "dataNascimentoCompare",
        "É necessário ter 18 anos na data do cadastro de pendente.",
        function (value) {
          const { idMovimento } = this.parent;
          const dataMov = parse(value, "dd/MM/yyyy", new Date());
          const dataNasc = new Date(dataNascimento);

          const diferencaEmAnos = differenceInYears(dataMov, dataNasc);

          const ehMenoA18Anos = diferencaEmAnos < 18;
          return !(ehMenoA18Anos && idMovimento?.id === 5 && !dataAnterior);
        }
      )
      .test("dataMovimentacaoCompare", "", function (value) {
        if (!intercalada) {
          let idCriancaFiltrada;

          if (table) {
            idCriancaFiltrada = data?.find(
              (item) => item.id === idCrianca || item.idCrianca === idCrianca
            );
          }

          const dataMovimentacaoEditar =
            movimentacaoEditar && movimentacaoDataAnterior?.dataMovimentacao
              ? movimentacaoDataAnterior?.dataMovimentacao
              : movimentacaoEditar &&
                !movimentacaoDataAnterior?.dataMovimentacao
              ? data[data.length - 1]?.dataMovimentacao
              : data[0]?.dataMovimentacao;

          const dataMovTimestamp =
            movimentoDefault && !table
              ? data?.movimentacoes[0]?.dataMovimentacao
              : movimentoDefault && table
              ? idCriancaFiltrada?.movimentacoes[0]?.dataMovimentacao
              : dataMovimentacaoEditar;

          const dataMov = dataMovTimestamp ? new Date(dataMovTimestamp) : null;

          if (!dataMov) {
            return false;
          }

          const valueDate = parse(value, "dd/MM/yyyy", new Date());

          dataMov?.setHours(0, 0, 0, 0);
          valueDate.setHours(0, 0, 0, 0);

          return !movimentacaoDataAnterior?.dataMovimentacao &&
            movimentacaoEditar
            ? true
            : valueDate.getTime() >= dataMov?.getTime();
        } else {
          return true;
        }
      })
      .test("data-movimentacao", "", function (value) {
        if (!intercalada) {
          const dataMovimentacaoPosteriorEditar =
            movimentacaoEditar && movimentacaoDataPosterior?.dataMovimentacao;

          const dataMovPosterior = dataMovimentacaoPosteriorEditar
            ? new Date(dataMovimentacaoPosteriorEditar)
            : null;

          if (!value) return true;
          if (!dataMovPosterior) return true;

          const valueDate = parse(value, "dd/MM/yyyy", new Date());

          valueDate?.setHours(0, 0, 0, 0);
          dataMovPosterior?.setHours(0, 0, 0, 0);

          return (
            movimentacaoEditar &&
            valueDate?.getTime() <= dataMovPosterior?.getTime()
          );
        } else {
          return true;
        }
      })
      .test("data-movimentacao-apadrinhamento", "", function (value) {
        if (!intercalada) {
          const dataMovimentacaoPosteriorApadrinhamentoEditar =
            movimentacaoEditar && movimentacaoData?.dataPrimeiroApadrinhamento;

          const dataMovPosterior = dataMovimentacaoPosteriorApadrinhamentoEditar
            ? new Date(dataMovimentacaoPosteriorApadrinhamentoEditar)
            : null;

          if (!value) return true;
          if (!dataMovPosterior) return true;

          const valueDate = parse(value, "dd/MM/yyyy", new Date());

          valueDate?.setHours(0, 0, 0, 0);
          dataMovPosterior?.setHours(0, 0, 0, 0);

          return (
            movimentacaoEditar &&
            valueDate?.getTime() <= dataMovPosterior?.getTime()
          );
        } else {
          return true;
        }
      })
      .test("dataNascimentoAfterToday", "", (value) => {
        if (!value) {
          return true;
        } else {
          return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
        }
      })
      .test(
        "dataMovimentacaoAfterVisita",
        "Existe uma visita cadastrada no período informado.",
        function (value) {
          const idMovimento = this.parent.idMovimento?.id;

          if (idMovimento === 4 && dataVisitas && !intercalada) {
            const data = new Date(dataVisitas);

            const valueDate = parse(value, "dd/MM/yyyy", new Date());

            data.setHours(0, 0, 0, 0);
            valueDate.setHours(0, 0, 0, 0);

            return valueDate >= data;
          }

          return true;
        }
      ),
    dataMovimentacaoFinal: Yup.string().when("id", {
      is: (id) => intercalada,
      then: Yup.string()
        .required("Este campo é obrigatório!")
        .test("validDate", "Data inválida!", (value) => {
          if (!!value) {
            if (value.length === 10) {
              return isValid(parse(value, "dd/MM/yyyy", new Date()));
            } else {
              return false;
            }
          } else {
            return false;
          }
        })
        .test(
          "dataNascimentoCompare",
          "A data do movimento não pode ser menor que a data de nascimento.",
          function (value) {
            const dataMov = parse(value, "dd/MM/yyyy", new Date());
            const dataNasc = new Date(dataNascimento);

            if (isAfter(dataNasc, dataMov)) {
              return false;
            }
            return true;
          }
        )
        .test("dataNascimentoAfterToday", "", (value) => {
          if (!value) {
            return true;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        })
        .test(
          "dataMovimentacaoAfterVisita",
          "Existe uma visita cadastrada no período informado.",
          function (value) {
            const idMovimentoFinal = this.parent.idMovimentoFinal?.id;

            if (idMovimentoFinal === 4 && dataVisitas && !intercalada) {
              const data = new Date(dataVisitas);

              const valueDate = parse(value, "dd/MM/yyyy", new Date());

              data.setHours(0, 0, 0, 0);
              valueDate.setHours(0, 0, 0, 0);

              return valueDate >= data;
            }

            return true;
          }
        ),
    }),

    idJustificativa: Yup.object().when("idMovimento.id", {
      is: (movimentoID) => movimentoID === 6,
      then: Yup.object().nullable().required("Este campo é obrigatório!"),
      otherwise: Yup.object().nullable(),
    }),

    idJustificativaFinal: Yup.object().when(["idMovimentoFinal.id"], {
      is: (movimentoID) => movimentoID === 2 && intercalada,
      then: Yup.object().nullable().required("Este campo é obrigatório!"),
      otherwise: Yup.object().nullable(),
    }),

    idMotivoSituacao: Yup.object().when("idMovimento.id", {
      is: (existeNova) => existeNova !== 1 && existeNova !== 6,
      then: Yup.object().nullable().required("Este campo é obrigatório!"),
      otherwise: Yup.object().nullable(),
    }),

    incluidoProgramaPPCAAM: Yup.object()
      .nullable()
      .when("idMotivoSituacao", {
        is: (motivo) => motivo && motivo.riscoVida === "S",
        then: Yup.object().required("Este campo é obrigatório!"),
      }),

    idMotivoSituacaoFinal: Yup.object().when(["idMovimentoFinal.id"], {
      is: (id) => id === 4 && intercalada,
      then: Yup.object().nullable().required("Este campo é obrigatório!"),
      otherwise: Yup.object().nullable(),
    }),
    dataValidadeTermoGuarda: Yup.string()
      .nullable()
      .test("validDate", "Data inválida!", (value) => {
        if (value && value.length === 10) {
          return isValid(parse(value, "dd/MM/yyyy", new Date()));
        } else if (value && value.length !== 10) {
          return false;
        }

        return true;
      })
      .test(
        "validDate",
        "A data de validade do termo de guarda não pode ser menor que a data corrente",
        (value) => {
          if (
            value &&
            value.length === 10 &&
            parse(value, "dd/MM/yyyy", new Date()).setHours(0, 0, 0, 0) !==
              new Date(
                movimentacaoData?.familiaAcolhedora?.validadeTermoGuarda
              ).setHours(0, 0, 0, 0)
          ) {
            const currentDate = new Date();
            const inputDate = parse(value, "dd/MM/yyyy", new Date());

            return (
              (isValid(inputDate) && isSameDay(inputDate, currentDate)) ||
              isAfter(inputDate, currentDate)
            );
          } else if (value && value.length !== 10) {
            return false;
          }

          return true;
        }
      ),
    dataValidadeTermoGuardaFinal: Yup.string().when(["id"], {
      is: (id) => intercalada,
      then: Yup.string()
        .test("validDate", "Data inválida!", (value) => {
          if (value && value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else if (value && value.length !== 10) {
            return false;
          }

          return true;
        })
        .test(
          "validDate",
          "A data de validade do termo de guarda não pode ser menor que a data corrente",
          (value) => {
            if (value && value.length === 10) {
              const currentDate = new Date();
              const inputDate = parse(value, "dd/MM/yyyy", new Date());
              return (
                (isValid(inputDate) && isSameDay(inputDate, currentDate)) ||
                isAfter(inputDate, currentDate)
              );
            } else if (value && value.length !== 10) {
              return false;
            }

            return true;
          }
        ),
    }),

    idServicoAcolhimento: Yup.object().when("idMovimento.id", {
      is: (idMovimentoId) => idMovimentoId !== 4 && idMovimentoId !== 6,
      then: Yup.object().nullable().required("Este campo é obrigatório"),
      otherwise: Yup.object(),
    }),

    idServicoAcolhimentoFinal: Yup.object().when(["idMovimentoFinal.id"], {
      is: (id) => id !== 4 && id !== 2 && intercalada,
      then: Yup.object().nullable().required("Este campo é obrigatório!"),
      otherwise: Yup.object().nullable(),
    }),
    cpfFamiliaAcolhedora: Yup.string()
      .when(
        [
          "idMovimento.id",
          "idServicoAcolhimento.tipoServicoAcolhimento.regime",
        ],
        {
          is: (idMovimento, regime) =>
            (idMovimento === 6 || idMovimento === 3 || idMovimento === 1) &&
            (regime === "SAF" ||
              initialValues?.idServicoAcolhimento?.regime === "SAF" ||
              (movimentoDefault &&
                data[0]?.servicoAcolhimento?.regime === "SAF") ||
              (idMovimento === 6 &&
                data[0]?.servicoAcolhimento?.regime === "SAF")),
          then: Yup.string()
            .required("Este campo é obrigatório!")
            .trim("Este campo é obrigatório!")
            .test("cpfValido", "", (value) => {
              if (!isValidCPF(value)) {
                return false;
              } else {
                return true;
              }
            })
            .test("unicidade", "", () => {
              if (criancaCPFValid) {
                return false;
              } else {
                return true;
              }
            })
            .test("messageValid", "", () => {
              if (messageValid) {
                return false;
              } else {
                return true;
              }
            }),
          otherwise: Yup.string(),
        }
      )
      .test(
        "notPermitFamily",
        "Não é permitido transferência para o(a) mesmo(a) acolhedor(a).",
        (value) => {
          if (mesmaFamilia) {
            return false;
          } else {
            return true;
          }
        }
      ),

    nomeFamiliaAcolhedora: Yup.string().when(
      ["idMovimento.id", "idServicoAcolhimento.tipoServicoAcolhimento.regime"],
      {
        is: (idMovimento, regime) =>
          (idMovimento === 6 || idMovimento === 3 || idMovimento === 1) &&
          (regime === "SAF" ||
            initialValues?.idServicoAcolhimento?.regime === "SAF" ||
            (movimentoDefault &&
              data[0]?.servicoAcolhimento?.regime === "SAF") ||
            (idMovimento === 6 &&
              data[0]?.servicoAcolhimento?.regime === "SAF")),
        then: Yup.string()
          .required("Este campo é obrigatório!")
          .trim("Este campo é obrigatório!"),
        otherwise: Yup.string(),
      }
    ),

    dataNascimentoFamiliaAcolhedora: Yup.string()
      .when(
        [
          "idMovimento.id",
          "idServicoAcolhimento.tipoServicoAcolhimento.regime",
        ],
        {
          is: (idMovimento, regime) =>
            (idMovimento === 6 || idMovimento === 3 || idMovimento === 1) &&
            (regime === "SAF" ||
              initialValues?.idServicoAcolhimento?.regime === "SAF" ||
              (movimentoDefault &&
                data[0]?.servicoAcolhimento?.regime === "SAF") ||
              (idMovimento === 6 &&
                data[0]?.servicoAcolhimento?.regime === "SAF")),
          then: Yup.string()
            .required("Este campo é obrigatório!")
            .nullable()
            .test("validDate", "Data inválida!", (value) => {
              if (!!value) {
                if (value.length === 10) {
                  return isValid(parse(value, "dd/MM/yyyy", new Date()));
                } else {
                  return false;
                }
              } else {
                return false;
              }
            }),
          otherwise: Yup.string(),
        }
      )
      .test("dataNascimentoAfterToday", "", (value) => {
        if (!value) {
          return true;
        } else {
          return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
        }
      }),

    idBairroFamiliaAcolhedora: Yup.object().when(
      ["idMovimento.id", "idServicoAcolhimento.tipoServicoAcolhimento.regime"],
      {
        is: (idMovimento, regime) =>
          (idMovimento === 6 || idMovimento === 3 || idMovimento === 1) &&
          (regime === "SAF" ||
            initialValues?.idServicoAcolhimento?.regime === "SAF" ||
            (movimentoDefault &&
              data[0]?.servicoAcolhimento?.regime === "SAF") ||
            (idMovimento === 6 &&
              data[0]?.servicoAcolhimento?.regime === "SAF")),
        then: Yup.object().nullable().required("Este campo é obrigatório!"),
        otherwise: Yup.object().nullable(),
      }
    ),

    idGeneroFamiliaAcolhedora: Yup.object().when(
      ["idMovimento.id", "idServicoAcolhimento.tipoServicoAcolhimento.regime"],
      {
        is: (idMovimento, regime) =>
          (idMovimento === 6 || idMovimento === 3 || idMovimento === 1) &&
          (regime === "SAF" ||
            initialValues?.idServicoAcolhimento?.regime === "SAF" ||
            (movimentoDefault &&
              data[0]?.servicoAcolhimento?.regime === "SAF") ||
            (idMovimento === 6 &&
              data[0]?.servicoAcolhimento?.regime === "SAF")),
        then: Yup.object().nullable().required("Este campo é obrigatório!"),
        otherwise: Yup.object().nullable(),
      }
    ),

    anexoTermoGuardaFamiliaAcolhedora: Yup.mixed().when(
      ["idMovimento.id", "idServicoAcolhimento.tipoServicoAcolhimento.regime"],
      {
        is: (idMovimento, regime) =>
          (idMovimento === 6 || idMovimento === 3 || idMovimento === 1) &&
          (regime === "SAF" ||
            initialValues?.idServicoAcolhimento?.regime === "SAF" ||
            (movimentoDefault &&
              data[0]?.servicoAcolhimento?.regime === "SAF") ||
            (idMovimento === 6 &&
              data[0]?.servicoAcolhimento?.regime === "SAF")),
        then: Yup.mixed()
          .nullable()
          .when(
            [
              "dataValidadeTermoGuarda",
              "originalAnexoTermoGuarda",
              "anexoTermoGuardaFamiliaAcolhedora",
            ],
            {
              is: (
                dataValidade,
                originalAnexoTermoGuarda,
                anexoTermoGuardaFamiliaAcolhedora
              ) =>
                dataValidade &&
                (!originalAnexoTermoGuarda || anexoGuiaEditadoTermoGuarda) &&
                !anexoTermoGuardaFamiliaAcolhedora,
              then: Yup.mixed().required("Este campo é obrigatório!"),
            }
          )
          .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
            if (value === null) {
              return true;
            } else {
              return value?.size <= 10000000;
            }
          })
          .test("fileType", "Anexar uma extensão válida.", (value) => {
            if (value === null) {
              return true;
            } else {
              let haveFormat = false;
              suportedFormats.forEach((format) => {
                if (value?.path?.toString().toLowerCase().includes(format)) {
                  haveFormat = true;
                }
              });
              return haveFormat;
            }
          }),
        otherwise: Yup.mixed().nullable(),
      }
    ),
    informacoesComplementares: Yup.string().when(
      ["idJustificativa.id", "idMovimento.id"],
      {
        is: (idJustificativa, idMovimento) => {
          return idJustificativa === 10 && idMovimento === 6;
        },

        then: Yup.string().trim().required("Este campo é obrigatório"),
        otherwise: Yup.string(),
      }
    ),
    informacoesComplementaresFinal: Yup.string().when(
      ["idJustificativaFinal.id", "idMovimentoFinal.id"],
      {
        is: (idJustificativaFinal, idMovimentoFinal) => {
          return idJustificativaFinal === 6 && idMovimentoFinal === 2;
        },

        then: Yup.string().trim().required("Este campo é obrigatório"),
        otherwise: Yup.string(),
      }
    ),
  });

  const schemaJustificativa = Yup.object().shape({
    idMovimento: Yup.object().required("Este campo é obrigatório").nullable(),
    idMovimentoFinal: Yup.object()
      .nullable()
      .when(["id"], {
        is: (id) => intercalada,
        then: Yup.object().nullable().required("Este campo é obrigatório"),
      }),

    anexoGuia: Yup.mixed()
      .nullable()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (!value) {
          return true;
        } else {
          return value?.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (
          value === null ||
          !value?.path ||
          typeof value?.path.toString !== "function"
        ) {
          return true;
        } else {
          const filePath = value?.path.toString().toLowerCase();

          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (filePath.includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),

    anexoGuiaFinal: Yup.mixed()
      .nullable()
      .test("fileSize", "O arquivo tem mais de 10MB.", (value) => {
        if (!value) {
          return true;
        } else {
          return value?.size <= 10000000;
        }
      })
      .test("fileType", "Anexar uma extensão válida.", (value) => {
        if (
          value === null ||
          !value?.path ||
          typeof value?.path.toString !== "function"
        ) {
          return true;
        } else {
          const filePath = value?.path.toString().toLowerCase();

          let haveFormat = false;
          suportedFormats.forEach((format) => {
            if (filePath.includes(format)) {
              haveFormat = true;
            }
          });
          return haveFormat;
        }
      }),

    dataMovimentacao: Yup.string()
      .nullable()
      .required("Este campo é obrigatório!")
      .test("validDate", "Data inválida!", (value) => {
        if (!!value) {
          if (value.length === 10) {
            return isValid(parse(value, "dd/MM/yyyy", new Date()));
          } else {
            return false;
          }
        } else {
          return false;
        }
      })
      .test(
        "dataNascimentoCompare",
        "A data do movimento, não pode ser menor que a data de nascimento.",
        function (value) {
          const dataMov = parse(value, "dd/MM/yyyy", new Date());
          const dataNasc = new Date(dataNascimento);

          if (isAfter(dataNasc, dataMov)) {
            return false;
          }
          return true;
        }
      )
      .test(
        "dataNascimentoCompare",
        "É necessário ter 18 anos na data do cadastro de pendente.",
        function (value) {
          const { idMovimento } = this.parent;
          const dataMov = parse(value, "dd/MM/yyyy", new Date());
          const dataNasc = new Date(dataNascimento);

          const diferencaEmAnos = differenceInYears(dataMov, dataNasc);

          const ehMenoA18Anos = diferencaEmAnos < 18;
          return !(ehMenoA18Anos && idMovimento?.id === 5 && !dataAnterior);
        }
      )
      .test("dataMovimentacaoCompare", "", function (value) {
        if (!intercalada) {
          let idCriancaFiltrada;

          if (table) {
            idCriancaFiltrada = data?.find(
              (item) => item.id === idCrianca || item.idCrianca === idCrianca
            );
          }

          const dataMovimentacaoEditar =
            movimentacaoEditar && movimentacaoDataAnterior?.dataMovimentacao
              ? movimentacaoDataAnterior?.dataMovimentacao
              : movimentacaoEditar &&
                !movimentacaoDataAnterior?.dataMovimentacao
              ? data[data.length - 1]?.dataMovimentacao
              : data[0]?.dataMovimentacao;

          const dataMovTimestamp =
            movimentoDefault && !table
              ? data?.movimentacoes[0]?.dataMovimentacao
              : movimentoDefault && table
              ? idCriancaFiltrada?.movimentacoes[0]?.dataMovimentacao
              : dataMovimentacaoEditar;

          const dataMov = dataMovTimestamp ? new Date(dataMovTimestamp) : null;

          if (!dataMov) {
            return false;
          }

          const valueDate = parse(value, "dd/MM/yyyy", new Date());

          dataMov?.setHours(0, 0, 0, 0);
          valueDate?.setHours(0, 0, 0, 0);

          return !movimentacaoDataAnterior?.dataMovimentacao &&
            movimentacaoEditar
            ? true
            : valueDate.getTime() >= dataMov?.getTime();
        } else {
          return true;
        }
      })
      .test("dataNascimentoAfterToday", "", (value) => {
        if (!value) {
          return true;
        } else {
          return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
        }
      }),
    dataMovimentacaoFinal: Yup.string().when(["id"], {
      is: (id) => intercalada,
      then: Yup.string()
        .required("Este campo é obrigatório!")
        .test("validDate", "Data inválida!", (value) => {
          if (!!value) {
            if (value.length === 10) {
              return isValid(parse(value, "dd/MM/yyyy", new Date()));
            } else {
              return false;
            }
          } else {
            return false;
          }
        })
        .test(
          "dataNascimentoCompare",
          "A data do movimento, não pode ser menor que a data de nascimento.",
          function (value) {
            const dataMov = parse(value, "dd/MM/yyyy", new Date());
            const dataNasc = new Date(dataNascimento);

            if (isAfter(dataNasc, dataMov)) {
              return false;
            }
            return true;
          }
        )
        .test("dataNascimentoAfterToday", "", (value) => {
          if (!value) {
            return true;
          } else {
            return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
          }
        }),
    }),

    idJustificativa: Yup.object()
      .nullable()
      .required("Este campo é obrigatório"),
    idJustificativaFinal: Yup.object().when(["idMovimentoFinal.id"], {
      is: (movimentoID) => movimentoID === 6 || intercalada,
      then: Yup.object().nullable().required("Este campo é obrigatório!"),
      otherwise: Yup.object().nullable(),
    }),

    informacoesComplementares: Yup.string().when("idJustificativa.id", {
      is: 6,
      then: Yup.string().required("Este campo é obrigatório"),
      otherwise: Yup.string(),
    }),
    informacoesComplementaresFinal: Yup.string().when(
      "idJustificativaFinal.id",
      {
        is: 6,
        then: Yup.string().required("Este campo é obrigatório"),
        otherwise: Yup.string(),
      }
    ),
  });

  const [shouldScrollInside, setShouldScrollInside] = useState(false);
  const modalContentRef = useRef(null);

  const UpdateScrollBehavior = ({ values }) => {
    useEffect(() => {
      setShouldScrollInside(!!values?.idMovimento);
    }, [values?.idMovimento]);

    return null;
  };

  const FocusErrorDate = () => {
    const { values, setFieldValue } = useFormikContext();
    const prevDataMovimentacao = useRef(values.dataMovimentacao);
    const prevDataMovimentacaoFinal = useRef(values.dataMovimentacaoFinal);

    useEffect(() => {
      if (prevDataMovimentacao.current !== values.dataMovimentacao) {
        setFieldValue("idMotivoSituacao", null);
        prevDataMovimentacao.current = values.dataMovimentacao;
      }

      if (prevDataMovimentacaoFinal.current !== values.dataMovimentacaoFinal) {
        setFieldValue("idMotivoSituacaoFinal", null);
        prevDataMovimentacaoFinal.current = values.dataMovimentacaoFinal;
      }
    }, [setFieldValue, values.dataMovimentacao, values.dataMovimentacaoFinal]);

    return null;
  };

  const FocusErrorData = () => {
    const { values, setFieldError } = useFormikContext();

    useEffect(() => {
      const validateDate = () => {
        const {
          dataMovimentacao,
          dataMovimentacaoFinal,
          cpfFamiliaAcolhedora,
          dataNascimentoFamiliaAcolhedora,
        } = values;
        const currentDate = new Date();

        if (dataMovimentacao) {
          const movementDate = parse(
            dataMovimentacao,
            "dd/MM/yyyy",
            new Date()
          );
          if (isAfter(movementDate, currentDate)) {
            setDataFutura(true);
            setDataAnterior(false);
            setDataPosterior(false);
            setDataApadrinhamentoPosterior(false);
          } else {
            setDataFutura(false);
          }
        }

        if (dataNascimentoFamiliaAcolhedora) {
          const movementDate = parse(
            dataNascimentoFamiliaAcolhedora,
            "dd/MM/yyyy",
            new Date()
          );
          if (isAfter(movementDate, currentDate)) {
            setDataNascimentoFuturaFamilia(true);
          } else {
            setDataNascimentoFuturaFamilia(false);
          }
        }
        if (dataMovimentacaoFinal) {
          const movementDate = parse(
            dataMovimentacaoFinal,
            "dd/MM/yyyy",
            new Date()
          );
          if (isAfter(movementDate, currentDate)) {
            setDataFuturaFinal(true);
          } else {
            setDataFuturaFinal(false);
          }
        }
        if (dataMovimentacao) {
          if (!intercalada) {
            let idCriancaFiltrada;

            if (table) {
              idCriancaFiltrada = data?.find(
                (item) => item.id === idCrianca || item.idCrianca === idCrianca
              );
            }

            const dataMovimentacaoPosteriorEditar = movimentacaoEditar
              ? movimentacaoDataPosterior?.dataMovimentacao
              : "";

            const dataMovimentacaoPosteriorApadrinhamentoEditar =
              movimentacaoEditar
                ? movimentacaoData?.dataPrimeiroApadrinhamento
                : "";

            const dataMovimentacaoEditar =
              movimentacaoEditar && movimentacaoDataAnterior?.dataMovimentacao
                ? movimentacaoDataAnterior?.dataMovimentacao
                : movimentacaoEditar &&
                  !movimentacaoDataAnterior?.dataMovimentacao
                ? data[data.length - 1]?.dataMovimentacao
                : data[0]?.dataMovimentacao;

            const dataMovTimestamp =
              movimentoDefault && !table
                ? data?.movimentacoes[0]?.dataMovimentacao
                : movimentoDefault && table
                ? idCriancaFiltrada?.movimentacoes[0]?.dataMovimentacao
                : dataMovimentacaoEditar;

            const dataMov = dataMovTimestamp
              ? new Date(dataMovTimestamp)
              : null;

            const dataMovPosterior = dataMovimentacaoPosteriorEditar
              ? new Date(dataMovimentacaoPosteriorEditar)
              : null;

            const dataMovApadrinhamentoPosterior =
              dataMovimentacaoPosteriorApadrinhamentoEditar
                ? new Date(dataMovimentacaoPosteriorApadrinhamentoEditar)
                : null;

            if (!dataMov) {
              setDataAnterior(false);
              setDataPosterior(false);
              setDataApadrinhamentoPosterior(false);
            }

            if (dataMovimentacao) {
              const valueDate = parse(
                dataMovimentacao,
                "dd/MM/yyyy",
                new Date()
              );

              dataMov?.setHours(0, 0, 0, 0);
              valueDate?.setHours(0, 0, 0, 0);
              dataMovPosterior?.setHours(0, 0, 0, 0);
              dataMovApadrinhamentoPosterior?.setHours(0, 0, 0, 0);

              if (valueDate.getTime() < dataMov?.getTime()) {
                if (movimentacaoDataAnterior) {
                  setDataAnterior(true);
                } else {
                  setDataAnterior(false);
                }
                setDataPosterior(false);
                setDataApadrinhamentoPosterior(false);
              } else if (
                movimentacaoEditar &&
                valueDate.getTime() > dataMovApadrinhamentoPosterior?.getTime()
              ) {
                setDataPosterior(false);
                setDataAnterior(false);
                setDataApadrinhamentoPosterior(true);
              } else if (
                movimentacaoEditar &&
                valueDate.getTime() > dataMovPosterior?.getTime()
              ) {
                setDataPosterior(true);
                setDataAnterior(false);
                setDataApadrinhamentoPosterior(false);
              } else {
                setDataPosterior(false);
                setDataAnterior(false);
                setDataApadrinhamentoPosterior(false);
              }
            }
          }
        }
        if (cpfFamiliaAcolhedora) {
          if (isValidCPF(cpfFamiliaAcolhedora)) {
            setInvalidCPF(true);
            setFieldError("cpfFamiliaAcolhedora", "");

            if (
              cpfFamiliaAcolhedora?.replace(/[.-]|[.-](?=.)/g, "").trim() !==
              movimentacaoData?.familiaAcolhedora?.cpf
            ) {
              CriancaService.validaCPFCrianca(
                idCrianca,
                cpfFamiliaAcolhedora,
                false
              )
                .then(() => setCriancaCPFValid(false))
                .catch((error) => {
                  console.log(error);
                  setCriancaCPFValid(true);
                });
            }
          } else {
            setInvalidCPF(false);
            setFieldError("cpfFamiliaAcolhedora", "");
          }
        }
      };

      validateDate();
    }, [values, values.dataNascimento, setFieldError]);

    return null;
  };

  const [movimentos, setMovimentos] = useState({
    options: [],
    isLoading: false,
  });

  const [movimentosFinais, setMovimentosFinais] = useState({
    options: [],
    isLoading: false,
  });

  const [tipoServico, setTipoServico] = useState("");
  const [tipoServicoFinal, setTipoServicoFinal] = useState("");
  const [servicos, setServicos] = useState({ options: [], isLoading: false });
  const [servicosFinal, setServicosFinal] = useState({
    options: [],
    isLoading: false,
  });

  const [crianca, setCrianca] = useState([]);

  const [motivos, setMotivos] = useState({
    options: [],
    isLoading: false,
  });
  const [motivosFinal, setMotivosFinal] = useState({
    options: [],
    isLoading: false,
  });
  const [justificativa, setJustificativa] = useState({
    options: [],
    isLoading: false,
  });

  const [justificativaFinal, setJustificativaFinal] = useState({
    options: [],
    isLoading: false,
  });
  const [justificativaId, setJustificativaId] = useState("");
  const [justificativaIdFinal, setJustificativaIdFinal] = useState("");

  const [existeNova, setExisteNova] = useState({
    options: [],
    isLoading: false,
  });

  const [existeNovaFinal, setExisteNovaFinal] = useState({
    options: [],
    isLoading: false,
  });

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isConfirmationModalOpenFinal, setIsConfirmationModalOpenFinal] =
    useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionFinal, setSelectedOptionFinal] = useState(null);
  const [, setLoadingVisitas] = useState(false);
  const [dataVisitas, setDataVisitas] = useState("");
  const [valueMovimentos, setValueMovimentos] = useState();
  const [valueMovimentosFinal, setValueMovimentosFinal] = useState();
  const [valueExiste, setValueExiste] = useState("");
  const [valueExisteFinal, setValueExisteFinal] = useState("");
  const [error, setError] = useState();
  const handleGetCrianca = useCallback(() => {
    CriancaService.getCrianca(idCrianca)
      .then((res) => {
        setCrianca(res?.data);
      })
      .catch(() => console.log("Erro no get de crianca"));
  }, [idCrianca]);

  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  useEffect(() => {
    if (movimentacaoData && movimentacaoEditar) {
      const padraoMovimentacao = {
        id: 3,
        tipoSituacao: {
          id: 1,
          descricao: "Acolhido",
        },
        descricao: "Entrada por Acolhimento",
        classificacao: "M",
      };

      setInitialValues((prevValues) => ({
        ...prevValues,
        idMovimento: movimentacaoData?.movimento
          ? movimentacaoData?.movimento
          : movimentacaoData?.ordem === 1
          ? padraoMovimentacao
          : "",

        dataMovimentacao: movimentacaoData?.dataMovimentacao
          ? isValid(movimentacaoData?.dataMovimentacao)
            ? format(new Date(movimentacaoData?.dataMovimentacao), "dd/MM/yyyy")
            : movimentacaoData?.dataMovimentacao
          : "",

        idMotivoSituacao: movimentacaoData?.motivoSituacao
          ? movimentacaoData?.motivoSituacao
          : "",
        incluidoProgramaPPCAAM:
          movimentacaoData?.incluidoProgramaPPCAAM === "S"
            ? { label: "Sim", value: "S" }
            : movimentacaoData?.incluidoProgramaPPCAAM === "N"
            ? { label: "Não", value: "N" }
            : "",
        numeroGuia: movimentacaoData?.numeroGuia
          ? mascaraNumeroGuia(movimentacaoData?.numeroGuia)
          : "",
        idJustificativa: movimentacaoData?.justificativa
          ? movimentacaoData?.justificativa
          : "",
        idServicoAcolhimento: movimentacaoData?.servicoAcolhimento
          ? movimentacaoData?.servicoAcolhimento
          : "",
        informacoesComplementares: movimentacaoData?.informacoesComplementares
          ? movimentacaoData?.informacoesComplementares
          : "",
        cpfFamiliaAcolhedora: movimentacaoData?.familiaAcolhedora?.cpf
          ? movimentacaoData?.familiaAcolhedora?.cpf
          : "",
        nomeFamiliaAcolhedora: movimentacaoData?.familiaAcolhedora?.nome
          ? movimentacaoData?.familiaAcolhedora?.nome
          : "",
        dataNascimentoFamiliaAcolhedora: movimentacaoData?.familiaAcolhedora
          ?.dataNascimento
          ? format(
              new Date(movimentacaoData?.familiaAcolhedora?.dataNascimento),
              "dd/MM/yyyy"
            )
          : "",
        idGeneroFamiliaAcolhedora: movimentacaoData?.familiaAcolhedora?.genero
          ? getGeneroLabel(movimentacaoData?.familiaAcolhedora?.genero)
          : "",
        idBairroFamiliaAcolhedora: movimentacaoData?.familiaAcolhedora?.bairro
          ? {
              id: movimentacaoData?.familiaAcolhedora?.idBairro,
              nome: movimentacaoData?.familiaAcolhedora?.bairro,
            }
          : "",
        dataValidadeTermoGuarda: movimentacaoData?.familiaAcolhedora
          ?.validadeTermoGuarda
          ? format(
              new Date(
                movimentacaoData?.familiaAcolhedora?.validadeTermoGuarda
              ),
              "dd/MM/yyyy"
            )
          : "",
        existeNovaGuiaAcolhimento:
          movimentacaoData.existeNovaGuiaAcolhimento === "S"
            ? { id: 1, descricao: "Sim" }
            : movimentacaoData.existeNovaGuiaAcolhimento === "N"
            ? { id: 2, descricao: "Não" }
            : "",
        anexoGuia: null,
        originalAnexoGuia: movimentacaoData?.anexoGuiaMovimentacao,
        originalAnexoTermoGuarda:
          movimentacaoData?.familiaAcolhedora?.anexoTermoGuarda,
        anexoTermoGuardaFamiliaAcolhedora: null,
      }));

      setValueMovimentos(
        movimentacaoData?.movimento
          ? movimentacaoData?.movimento
          : movimentacaoData?.ordem === 1
          ? padraoMovimentacao
          : ""
      );
    } else {
      setInitialValues((prevValues) => ({
        ...prevValues,
        idMovimento: "",
      }));
    }
  }, [movimentacaoData, movimentacaoEditar]);

  const handleConfirmAction = (props) => {
    props.setFieldValue("idMotivoSituacao", selectedOption);

    props.setFieldValue("idMotivoSituacaoFinal", selectedOptionFinal);

    setIsConfirmationModalOpen(false);
    setIsConfirmationModalOpenFinal(false);
  };

  const fetchVisitasData = useCallback(() => {
    if (idCrianca) {
      setLoadingVisitas(true);
      VisitasService.visualizarVisitaCrianca(idCrianca)
        .then((res) => {
          const dataOrdenada = res.data.content.sort((a, b) => {
            const ultimaVisitaA = a.ultimaVisita;
            const ultimaVisitaB = b.ultimaVisita;
            return ultimaVisitaB - ultimaVisitaA;
          });

          setDataVisitas(dataOrdenada[0]?.ultimaVisita);
          setLoadingVisitas(false);
        })
        .catch((error) => {
          console.log("Error no getReferencia", error);
          setLoadingVisitas(false);
        });
    }
  }, [idCrianca]);

  useEffect(() => {
    handleGetCrianca();
  }, [handleGetCrianca]);

  useEffect(() => {
    fetchVisitasData();
  }, [fetchVisitasData]);

  const handleGetMovimentos = (value) => {
    setMovimentos({ ...movimentos, isLoading: true });
    setMovimentosFinais({ ...movimentosFinais, isLoading: true });

    MovimentoService.getMovimento()
      .then((res) => {
        const dataDoTimestamp = crianca?.dataNascimento
          ? new Date(crianca?.dataNascimento)
          : null;
        const dataAtual = new Date();

        const diferencaEmAnos = differenceInYears(dataAtual, dataDoTimestamp);
        const ehMaiorOuIgualA18Anos = diferencaEmAnos >= 18;

        const stepMotivo = movimentacaoEditar
          ? movimentacaoDataAnterior?.motivoSituacao
          : data[0]?.motivoSituacao;

        const stepMovimento = movimentacaoEditar
          ? movimentacaoDataAnterior?.movimento
          : data[0]?.movimento;
        const descricao = movimentacaoEditar
          ? movimentacaoDataAnterior?.movimento?.id
          : data[0]?.movimento?.id;
        const tipoServicoAcolhimento = movimentacaoEditar
          ? movimentacaoDataAnterior?.servicoAcolhimento
          : data[0]?.servicoAcolhimento;

        const filtroComum = res.data.filter((item) =>
          tipoServicoAcolhimento?.regime !== "SAF" ? item.id !== 6 : item
        );

        if (intercalada) {
          if (value === "inicial") {
            const filtrado = res.data
              .filter(
                (item) =>
                  item.id !== 2 &&
                  item.id !== 4 &&
                  item.id !== 5 &&
                  item.id !== 6
              )
              .map((item) => {
                return item;
              });
            setMovimentos({ options: filtrado, isLoading: false });
          } else {
            const filtrado = res.data
              .filter(
                (item) =>
                  item.id !== 3 &&
                  item.id !== 1 &&
                  item.id !== 5 &&
                  item.id !== 6
              )
              .map((item) => {
                return item;
              });
            setMovimentosFinais({ options: filtrado, isLoading: false });
          }
        } else {
          if (
            !stepMovimento &&
            !stepMotivo &&
            !descricao &&
            !tipoServicoAcolhimento &&
            !movimentoDefault
          ) {
            let filtrado;
            filtrado = filtroComum
              .filter(
                (item) =>
                  item.id !== 1 &&
                  item.id !== 2 &&
                  item.id !== 4 &&
                  item.id !== 5 &&
                  item.id !== 6
              )
              .map((item) => {
                return item;
              });

            !movimentoDefault &&
              (filtrado = handleVerifyMovimento(
                filtrado,
                roleKeycloack,
                user,
                idPJ
              ));
            setMovimentos({ options: filtrado, isLoading: false });
          } else {
            if (
              stepMovimento?.tipoSituacao.id === 1 ||
              stepMotivo?.tipoSituacao.id === 1
            ) {
              if (ehMaiorOuIgualA18Anos) {
                let filtrado;
                if (descricao === 2) {
                  filtrado = filtroComum
                    .filter(
                      (item) =>
                        item.id !== 6 &&
                        item.id !== 5 &&
                        item.id !== 4 &&
                        item.id !== 2
                    )
                    .map((item) => {
                      return item;
                    });
                } else {
                  filtrado = filtroComum

                    .filter((item) => item.id !== 3 && item.id !== 1)
                    .map((item) => {
                      return item;
                    });
                }

                !movimentoDefault &&
                  (filtrado = handleVerifyMovimento(
                    filtrado,
                    roleKeycloack,
                    user,
                    idPJ
                  ));
                setMovimentos({ options: filtrado, isLoading: false });
              } else {
                let filtrado;

                if (descricao === 2) {
                  filtrado = filtroComum
                    .filter(
                      (item) =>
                        item.id !== 5 &&
                        item.id !== 6 &&
                        item.id !== 4 &&
                        item.id !== 2
                    )
                    .map((item) => {
                      return item;
                    });
                } else {
                  filtrado = filtroComum
                    .filter(
                      (item) => item.id !== 3 && item.id !== 1 && item.id !== 5
                    )
                    .map((item) => {
                      return item;
                    });
                }

                !movimentoDefault &&
                  (filtrado = handleVerifyMovimento(
                    filtrado,
                    roleKeycloack,
                    user,
                    idPJ
                  ));
                setMovimentos({ options: filtrado, isLoading: false });
              }
            } else if (
              stepMovimento?.tipoSituacao.id === 2 ||
              stepMotivo?.tipoSituacao.id === 2 ||
              movimentoDefault
            ) {
              let filtrado = res.data
                .filter(
                  (item) =>
                    item.id !== 2 &&
                    item.id !== 4 &&
                    item.id !== 5 &&
                    item.id !== 6
                )
                .map((item) => {
                  return item;
                });
              !movimentoDefault &&
                (filtrado = handleVerifyMovimento(
                  filtrado,
                  roleKeycloack,
                  user,
                  idPJ
                ));
              setMovimentos({ options: filtrado, isLoading: false });
            } else if (stepMovimento?.tipoSituacao.id === 3 || !stepMotivo) {
              let filtrado = res.data
                .filter((item) => item.id === 4)
                .map((item) => {
                  return item;
                });
              !movimentoDefault &&
                (filtrado = handleVerifyMovimento(
                  filtrado,
                  roleKeycloack,
                  user,
                  idPJ
                ));
              setMovimentos({ options: filtrado, isLoading: false });
            }
          }
        }
      })

      .catch(() => console.log("Erro no get de movimentos"));
  };

  const handleGetMotivos = (dataMovimentacao) => {
    setMotivos({ ...motivos, isLoading: true });
    setMotivosFinal({ ...motivosFinal, isLoading: true });

    MotivoSituacaoService.listarMotivoSituacao()
      .then((res) => {
        let motivoSituacaoDesligado = res.data
          .filter((item) => item.tipoSituacao.id === 2 && item.dataFim === null)
          .map((item) => {
            return item;
          });
        let motivoSituacaoAcolhido = res.data
          .filter((item) => item.tipoSituacao.id === 1 && item.dataFim === null)
          .map((item) => {
            return item;
          });

        if (dataNascimento && dataMovimentacao) {
          const formattedDate = new Date(dataNascimento);
          const parsedDate = parse(dataMovimentacao, "dd/MM/yyyy", new Date());

          const umAnoDepois = addYears(formattedDate, 1);
          const dentroUmAno = parsedDate <= umAnoDepois;

          if (!dentroUmAno) {
            motivoSituacaoAcolhido = motivoSituacaoAcolhido.filter(
              (item) => item.extincaoPoderFamiliar !== "S"
            );
            motivoSituacaoDesligado = motivoSituacaoDesligado.filter(
              (item) => item.extincaoPoderFamiliar !== "S"
            );
          }
        }

        if (valueMovimentos?.id === 4) {
          setMotivos({ options: motivoSituacaoDesligado, isLoading: false });
        } else if (valueMovimentos?.id === 3 || movimentoDefault) {
          setMotivos({ options: motivoSituacaoAcolhido, isLoading: false });
        }

        if (valueMovimentosFinal?.id === 4) {
          setMotivosFinal({
            options: motivoSituacaoDesligado,
            isLoading: false,
          });
        } else if (valueMovimentos?.id === 3 || movimentoDefault) {
          setMotivosFinal({
            options: motivoSituacaoAcolhido,
            isLoading: false,
          });
        }
      })
      .catch(() => console.log("Erro no get de motivos"));
  };

  const handleGetJustificativa = (value) => {
    setJustificativa({ ...justificativa, isLoading: true });
    setJustificativaFinal({ ...justificativaFinal, isLoading: true });

    if (value === "inicial") {
      JustificativaService.getJustificativa(valueMovimentos.id)
        .then((res) => {
          setJustificativa({ options: res.data, isLoading: false });
        })
        .catch(() => console.log("Erro no get de justificativa"));
    } else if (value === "final") {
      JustificativaService.getJustificativa(valueMovimentosFinal.id).then(
        (res) => {
          setJustificativaFinal({ options: res.data, isLoading: false });
        }
      );
    }
  };

  const handleGetExistehaNovaGuiaAcolhimento = () => {
    setExisteNova({ ...existeNova, isLoading: true });
    setExisteNovaFinal({ ...existeNovaFinal, isLoading: true });

    setExisteNova({
      options: [
        { id: 1, descricao: "Sim" },
        { id: 2, descricao: "Não" },
      ],
      isLoading: false,
    });

    setExisteNovaFinal({
      options: [
        { id: 1, descricao: "Sim" },
        { id: 2, descricao: "Não" },
      ],
      isLoading: false,
    });
  };

  const handleGetServicos = (value) => {
    setServicos({ ...servicos, isLoading: true });
    setServicosFinal({ ...servicosFinal, isLoading: true });
    if (gestor || intercalada) {
      ServicoAcolhimentoService.listarServicosAcolhimento().then((res) => {
        const filteredData = res.data.filter((item) => !!item.pessoaJuridica);
        if (value === "inicial") {
          setServicos({ options: filteredData, isLoading: false });
        } else {
          setServicosFinal({ options: filteredData, isLoading: false });
        }
      });
    } else {
      ServicoAcolhimentoService.listarServicosAcolhimentoSoAtivos().then(
        (res) => {
          let filteredData = res.data.filter((item) => !!item.pessoaJuridica);
          if (value === "inicial") {
            if (
              (movimentoDefault || movimentacaoData) &&
              (roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
                roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar))
            ) {
              filteredData = filteredData.filter((item) =>
                user.orgaoExterno?.includes(item.pessoaJuridica.id)
              );
            } else if (
              movimentacaoData &&
              ministerioPublico &&
              movimentacaoEditar
            ) {
              filteredData = filteredData.filter((item) =>
                user?.orgaos.some((orgao) => orgao?.id === item?.promotoria?.id)
              );
            }

            setServicos({ options: filteredData, isLoading: false });
          } else {
            setServicosFinal({ options: filteredData, isLoading: false });
          }
        }
      );
    }
  };

  const adicionarAnexo = async (id, idCrianca, anexo, idMovimento) => {
    try {
      if (idMovimento === 4) {
        await MovimentacaoService.postAnexoMovimentacaoDesligamento(
          id,
          idCrianca,
          anexo
        );
      } else if (idMovimento === 5) {
        await MovimentacaoService.postAnexoMovimentacaoPendente(
          id,
          idCrianca,
          anexo
        );
      } else {
        await MovimentacaoService.postAnexoMovimentacaoAcolhimento(
          id,
          idCrianca,
          anexo
        );
      }
    } catch (error) {
      console.error("Erro ao adicionar Anexo Guia:", error);
    }
  };

  const deleteAnexoGuiaOrTermoGuarda = async (idAnexo) => {
    try {
      await CriancaService.deleteAnexoCrianca(idAnexo);
    } catch (error) {
      console.error("Erro ao deletar Anexo Guia:", error);
    }
  };

  const adicionarAnexoTermoGuarda = async (
    idSA,
    idCrianca,
    anexo,
    timesTamp,
    cpf
  ) => {
    try {
      await FamiliaAcolhedoraSAService.postFamiliaAcolhedoraTermoGuarda(
        idSA,
        idCrianca,
        anexo,
        timesTamp,
        cpf
      );
    } catch (error) {
      console.error("Erro ao adicionar Termo de guarda:", error);
    }
  };

  const formRef = useRef(null);

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const splitDate = values?.dataMovimentacao.split("/");
      const splitDateFinal = values?.dataMovimentacaoFinal.split("/");
      const year = parseInt(splitDate[2]);
      const month = parseInt(splitDate[1]) - 1;
      const day = parseInt(splitDate[0]);
      const now = new Date();
      const yearFinal = parseInt(splitDateFinal[2]);
      const monthFinal = parseInt(splitDateFinal[1]) - 1;
      const dayFinal = parseInt(splitDateFinal[0]);
      const nowFinal = new Date();

      const formattedDate = new Date(
        year,
        month,
        day,
        now.getHours(),
        now.getMinutes(),
        now.getSeconds()
      );

      const formattedDateFinal = new Date(
        yearFinal,
        monthFinal,
        dayFinal,
        nowFinal.getHours(),
        nowFinal.getMinutes(),
        nowFinal.getSeconds()
      );
      const formattedDateString = format(
        formattedDate,
        "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"
      );

      const formattedDateStringFinal = values.dataMovimentacaoFinal
        ? format(formattedDateFinal, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
        : "";

      const {
        anexoGuia,
        anexoTermoGuardaFamiliaAcolhedora,
        existeNovaGuiaAcolhimento,
        anexoGuiaFinal,
      } = values;

      const movimentoInicial = {
        dataMovimentacao: formattedDateString,
        idMotivoSituacao: values?.idMotivoSituacao?.id,
        incluidoProgramaPPCAAM:
          values?.incluidoProgramaPPCAAM &&
          values?.idMotivoSituacao?.riscoVida === "S"
            ? values?.incluidoProgramaPPCAAM.value
            : "",
        idMovimento: values?.idMovimento?.id,
        idServicoAcolhimento:
          values?.idMovimento?.id === 6
            ? data[0]?.servicoAcolhimento?.id
            : values?.idServicoAcolhimento?.id,
        idServicoAcolhimentoDestino: 0,
        informacoesComplementares: values?.informacoesComplementares,
        numeroGuia: values?.idMovimento?.id === 2 ? "" : values?.numeroGuia,

        orgaoResponsavel: "SERVICO_ACOLHMENTO",
      };

      if (!intercalada) {
        movimentoInicial.idMovimentoAnterior = movimentacaoEditar
          ? movimentacaoDataAnterior?.id
          : ultimaMovimentacaoBuscar;
      }

      const movimentoFinal = {
        dataMovimentacao: formattedDateStringFinal,
        idMotivoSituacao: values?.idMotivoSituacaoFinal?.id,
        idMovimento: values?.idMovimentoFinal?.id,
        idServicoAcolhimento:
          values?.idMovimentoFinal?.id === 6
            ? data[0]?.servicoAcolhimento?.id
            : values?.idServicoAcolhimentoFinal?.id,
        idServicoAcolhimentoDestino: 0,
        informacoesComplementares: values?.informacoesComplementaresFinal,
        numeroGuia: values?.numeroGuiaFinal,

        orgaoResponsavel: "SERVICO_ACOLHMENTO",
      };

      const valuesToSend = {
        cpfAcolhedor: values.cpfFamiliaAcolhedora
          ? values.cpfFamiliaAcolhedora.replace(/[.-]|[.-](?=.)/g, "").trim()
          : "",
        nome: values.nomeFamiliaAcolhedora
          ? values.nomeFamiliaAcolhedora.trim()
          : "",
        dataNascimento: values.dataNascimentoFamiliaAcolhedora
          ? parse(
              values.dataNascimentoFamiliaAcolhedora,
              "dd/MM/yyyy",
              new Date()
            ).toISOString()
          : "",
        idGenero: values.idGeneroFamiliaAcolhedora
          ? values.idGeneroFamiliaAcolhedora.id
          : "",
        idCrianca: !table ? Number(idCrianca) : Number(idCrianca),
        idBairro: values.idBairroFamiliaAcolhedora
          ? values.idBairroFamiliaAcolhedora.id
          : "",
        dataValidadeTermoGuarda: values.dataValidadeTermoGuarda
          ? parse(
              values.dataValidadeTermoGuarda,
              "dd/MM/yyyy",
              new Date()
            ).toISOString()
          : "",
      };

      const Imagens = {
        anexoGuia: anexoGuia ? anexoGuia : "",
        anexoTermoGuardaFamiliaAcolhedora: anexoTermoGuardaFamiliaAcolhedora
          ? anexoTermoGuardaFamiliaAcolhedora
          : "",
        anexoGuiaFinal: anexoGuiaFinal ? anexoGuiaFinal : "",
      };

      if (valueMovimentos?.classificacao === "J" || valueMovimentos?.id === 6) {
        movimentoInicial.idJustificativa = values?.idJustificativa?.id;
      }

      if (
        valueMovimentosFinal?.classificacao === "J" ||
        valueMovimentosFinal?.id === 6
      ) {
        movimentoFinal.idJustificativaFinal = values?.idJustificativaFinal?.id;
      }

      try {
        if (intercalada) {
          if (
            values?.idServicoAcolhimento?.tipoServicoAcolhimento?.regime ===
              "SAF" ||
            values?.idServicoAcolhimento?.regime === "SAF"
          ) {
            if (
              (valueMovimentosFinal.options &&
                valueMovimentosFinal.options[0]?.id === 1) ||
              (valueMovimentosFinal && valueMovimentosFinal?.id === 1)
            ) {
              movimentoInicial.existeNovaGuiaAcolhimento =
                existeNovaGuiaAcolhimento.id === 1
                  ? "S"
                  : existeNovaGuiaAcolhimento.id === 2
                  ? "N"
                  : "";
            }
            const movimentoInicialFamilia = {
              ...movimentoInicial,
              familiaAcolhedora: { ...valuesToSend },
            };

            const valuesToSendFamilia = {
              movimentoInicial: movimentoInicialFamilia,
              movimentoFinal: movimentoFinal,
            };

            MovimentacaoService.postMovimentacoesIntercaladasFamilia(
              idCrianca,
              valuesToSendFamilia
            )
              .then((res) => {
                onClose();
                setValueMovimentos("");
                setValueMovimentosFinal("");
                setError("");

                const { id } = res.data.movimentoInicial;
                const { id: idMovimentacaoFinal } = res.data.movimentoFinal;

                if (id && idCrianca && Imagens.anexoGuia) {
                  adicionarAnexo(
                    id,
                    idCrianca,
                    Imagens.anexoGuia,
                    valueMovimentos?.id
                  );
                }

                if (Imagens.anexoGuiaFinal && idMovimentacaoFinal) {
                  adicionarAnexo(
                    idMovimentacaoFinal,
                    idCrianca,
                    Imagens.anexoGuiaFinal,
                    valueMovimentos?.id
                  );
                }

                if (Imagens?.anexoTermoGuardaFamiliaAcolhedora) {
                  const parsedDataValidadeTermoGuarda =
                    valuesToSend.dataValidadeTermoGuarda
                      ? Date.parse(valuesToSend.dataValidadeTermoGuarda)
                      : "";

                  adicionarAnexoTermoGuarda(
                    movimentoInicial.idServicoAcolhimento,
                    idCrianca,
                    Imagens.anexoTermoGuardaFamiliaAcolhedora,

                    parsedDataValidadeTermoGuarda,
                    valuesToSend.cpfAcolhedor
                  );
                }

                if (!table) {
                  setLoadingPainel(true);
                } else {
                  if (fetchFunc) {
                    fetchFunc();
                  } else {
                    atualizarDados(true);
                  }
                }

                setLoadingCadastro && setLoadingCadastro(true);
                setLoadingHistorico && setLoadingHistorico(true);
                Swal.fire({
                  title: "Sucesso!",
                  text: "Registro cadastrado com sucesso!",
                  icon: "success",
                  confirmButtonText: "Continuar",
                  confirmButtonColor: "#169499",
                });
              })
              .catch((error) => {
                console.log(error);
                Swal.fire({
                  title: "Atenção!",
                  html: error.response?.data?.message
                    ? error.response?.data?.message
                    : "",
                  icon: "warning",
                  confirmButtonText: "Fechar",
                  confirmButtonColor: "#169499",
                });
              });
          } else {
            if (
              (valueMovimentos.options &&
                valueMovimentos.options[0]?.id === 1) ||
              (valueMovimentos && valueMovimentos?.id === 1)
            ) {
              movimentoInicial.existeNovaGuiaAcolhimento =
                existeNovaGuiaAcolhimento.id === 1
                  ? "S"
                  : existeNovaGuiaAcolhimento.id === 2
                  ? "N"
                  : "";
            }

            MovimentacaoService.postMovimentacoesIntercaladas(idCrianca, {
              movimentoFinal,
              movimentoInicial,
            })
              .then((res) => {
                onClose();
                setValueMovimentos("");
                setValueMovimentosFinal("");
                setError("");

                const { id } = res.data.movimentoInicial;
                const { id: idMovimentacaoFinal } = res.data.movimentoFinal;

                if (id && idCrianca && Imagens.anexoGuia) {
                  adicionarAnexo(
                    id,
                    idCrianca,
                    Imagens.anexoGuia,
                    valueMovimentos?.id
                  );
                }

                if (Imagens.anexoGuiaFinal && idMovimentacaoFinal) {
                  adicionarAnexo(
                    idMovimentacaoFinal,
                    idCrianca,
                    Imagens.anexoGuiaFinal,
                    valueMovimentos?.id
                  );
                }

                if (!table) {
                  setLoadingPainel(true);
                } else {
                  if (fetchFunc) {
                    fetchFunc();
                  } else {
                    atualizarDados(true);
                  }
                }
                setLoadingCadastro && setLoadingCadastro(true);
                setLoadingHistorico && setLoadingHistorico(true);
                Swal.fire({
                  title: "Sucesso!",
                  text: "Registro cadastrado com sucesso!",
                  icon: "success",
                  confirmButtonText: "Continuar",
                  confirmButtonColor: "#169499",
                });
              })
              .catch((error) => {
                console.log(error);
                Swal.fire({
                  title: "Atenção!",
                  html: error.response?.data?.message
                    ? error.response?.data?.message
                    : "",
                  icon: "warning",
                  confirmButtonText: "Fechar",
                  confirmButtonColor: "#169499",
                });
              });
          }
        } else {
          if (
            ((valueMovimentos.options
              ? valueMovimentos?.options[0]?.id === 3 ||
                valueMovimentos?.options[0]?.id === 6 ||
                valueMovimentos?.options[0]?.id === 1
              : false) &&
              (values?.idServicoAcolhimento?.tipoServicoAcolhimento?.regime ===
                "SAF" ||
                values?.idServicoAcolhimento?.regime === "SAF" ||
                (movimentoDefault &&
                  data[0]?.servicoAcolhimento?.regime === "SAF"))) ||
            ((valueMovimentos
              ? valueMovimentos?.id === 3 ||
                valueMovimentos?.id === 6 ||
                valueMovimentos?.id === 1
              : false) &&
              (values?.idServicoAcolhimento?.tipoServicoAcolhimento?.regime ===
                "SAF" ||
                values?.idServicoAcolhimento?.regime === "SAF" ||
                (movimentoDefault &&
                  data[0]?.servicoAcolhimento?.regime === "SAF") ||
                (valueMovimentos?.id === 6 &&
                  data[0]?.servicoAcolhimento?.regime === "SAF")))
          ) {
            if (
              (valueMovimentos.options &&
                valueMovimentos.options[0]?.id === 1) ||
              (valueMovimentos && valueMovimentos?.id === 1)
            ) {
              movimentoInicial.existeNovaGuiaAcolhimento =
                existeNovaGuiaAcolhimento.id === 1
                  ? "S"
                  : existeNovaGuiaAcolhimento.id === 2
                  ? "N"
                  : "";
            }

            const valuesToSendFamilia = {
              ...movimentoInicial,
              familiaAcolhedora: { ...valuesToSend },
            };

            const movimentacaoFamiliaRequest = movimentacaoEditar
              ? (idCrianca, body) =>
                  MovimentacaoService.putMovimentacoesFamilia(
                    idCrianca,
                    movimentacaoData?.id,
                    body
                  )
              : (idCrianca, body) =>
                  MovimentacaoService.postMovimentacoesFamilia(idCrianca, body);

            movimentacaoFamiliaRequest(idCrianca, valuesToSendFamilia)
              .then((res) => {
                const { idCrianca: idCriancaResponse, idMovimentacao } =
                  res.data;

                onClose();
                setValueMovimentos("");
                setValueMovimentosFinal("");
                setError("");

                if (
                  !movimentacaoEditar &&
                  idMovimentacao &&
                  idCriancaResponse &&
                  Imagens.anexoGuia
                ) {
                  adicionarAnexo(
                    idMovimentacao,
                    idCriancaResponse,
                    Imagens.anexoGuia,
                    valueMovimentos?.id
                  );
                }

                if (Imagens?.anexoTermoGuardaFamiliaAcolhedora) {
                  const parsedDataValidadeTermoGuarda =
                    valuesToSend.dataValidadeTermoGuarda
                      ? Date.parse(valuesToSend.dataValidadeTermoGuarda)
                      : "";

                  adicionarAnexoTermoGuarda(
                    movimentoInicial.idServicoAcolhimento,
                    idCriancaResponse,
                    Imagens.anexoTermoGuardaFamiliaAcolhedora,

                    parsedDataValidadeTermoGuarda,
                    valuesToSend.cpfAcolhedor
                  );
                }

                if (movimentacaoEditar) {
                  if (movimentacaoData.id && Imagens.anexoGuia && idCrianca) {
                    adicionarAnexo(
                      movimentacaoData.id,
                      idCrianca,
                      Imagens.anexoGuia,
                      valueMovimentos?.id
                    );
                  }

                  if (
                    movimentacaoData?.anexoGuiaMovimentacao?.idAnexo &&
                    !Imagens.anexoGuia &&
                    anexoGuiaEditado
                  ) {
                    deleteAnexoGuiaOrTermoGuarda(
                      movimentacaoData?.anexoGuiaMovimentacao?.idAnexo
                    );
                  }

                  if (
                    movimentacaoData?.familiaAcolhedora?.anexoTermoGuarda
                      ?.idAnexo &&
                    !Imagens.anexoTermoGuardaFamiliaAcolhedora &&
                    anexoGuiaEditadoTermoGuarda
                  ) {
                    deleteAnexoGuiaOrTermoGuarda(
                      movimentacaoData?.familiaAcolhedora?.anexoTermoGuarda
                        ?.idAnexo
                    );
                  }
                }

                if (!table) {
                  setLoadingPainel(true);
                } else {
                  if (fetchFunc) {
                    fetchFunc();
                  } else {
                    atualizarDados(true);
                  }
                }

                setLoadingCadastro && setLoadingCadastro(true);
                setLoadingCadastro && setLoadingHistorico(true);
                handleGetCriancaReload && handleGetCriancaReload();
                setAnexoGuiaEditado(false);
                setMovimentacaoData({});
                setMovimentos({
                  options: [],
                  isLoading: false,
                });
                setMovimentacaoEditar(false);
                setAnexoGuiaEditadoTermoGuarda(false);
                setDisabledMPTJ(false);
                setDisabledPPCAAM(false);

                if (tableCrianca) {
                  history.push(`/crianca/${idCrianca}`);
                }
                Swal.fire({
                  title: "Sucesso!",
                  text: "Registro cadastrado com sucesso!",
                  icon: "success",
                  confirmButtonText: "Continuar",
                  confirmButtonColor: "#169499",
                }).then((result) => {
                  if (
                    valueMovimentos &&
                    (valueMovimentos?.id === 4 || valueMovimentos?.id === 2) &&
                    (roleKeycloack?.includes(
                      criancaFunc.visualizarTudoAcolhimento
                    ) ||
                      roleKeycloack?.includes(
                        criancaFunc.visualizarTudoTutelar
                      ))
                  ) {
                    history.push(`/crianca/${idCrianca}`);
                  }
                });
              })
              .catch((error) => {
                console.log(error);
                Swal.fire({
                  title: "Atenção!",
                  html: error.response?.data?.message
                    ? error.response?.data?.message
                    : "",
                  icon: "warning",
                  confirmButtonText: "Fechar",
                  confirmButtonColor: "#169499",
                });
              })
              .catch((error) => {
                console.log(error);
                Swal.fire({
                  title: "Atenção!",
                  html: error.response.data.apierror.subErrors[0].message
                    ? error.response.data.apierror.subErrors[0].message
                    : "",
                  icon: "warning",
                  confirmButtonText: "Fechar",
                  confirmButtonColor: "#169499",
                });
              });
          } else {
            const movimentacaoRequest = movimentacaoEditar
              ? (idCrianca, body) =>
                  MovimentacaoService.putMovimentacoes(
                    idCrianca,
                    movimentacaoData?.id,
                    body
                  )
              : (idCrianca, body) =>
                  MovimentacaoService.postMovimentacoes(idCrianca, body);

            if (
              (valueMovimentos.options &&
                valueMovimentos.options[0]?.id === 1) ||
              (valueMovimentos && valueMovimentos?.id === 1)
            ) {
              movimentoInicial.existeNovaGuiaAcolhimento =
                existeNovaGuiaAcolhimento.id === 1
                  ? "S"
                  : existeNovaGuiaAcolhimento.id === 2
                  ? "N"
                  : "";
            }

            movimentacaoRequest(
              !table ? idCrianca : idCrianca,
              movimentoInicial
            )
              .then((res) => {
                onClose();
                setValueMovimentos("");
                setValueMovimentosFinal("");
                setError("");
                const { idMovimentacao, idCrianca: idCriancaResponse } =
                  res.data;

                if (
                  idMovimentacao &&
                  idCriancaResponse &&
                  Imagens.anexoGuia &&
                  !movimentacaoEditar
                ) {
                  adicionarAnexo(
                    idMovimentacao,
                    idCriancaResponse,
                    Imagens.anexoGuia,
                    valueMovimentos?.id
                  );
                }

                if (movimentacaoEditar) {
                  if (movimentacaoData.id && idCrianca && Imagens.anexoGuia) {
                    adicionarAnexo(
                      movimentacaoData.id,
                      idCrianca,
                      Imagens.anexoGuia,
                      valueMovimentos?.id
                    );
                  }

                  if (
                    (movimentacaoData?.anexoGuiaMovimentacao?.idAnexo &&
                      !Imagens.anexoGuia &&
                      anexoGuiaEditado) ||
                    (values?.originalAnexoGuia && values?.idMovimento?.id === 2)
                  ) {
                    deleteAnexoGuiaOrTermoGuarda(
                      movimentacaoData?.anexoGuiaMovimentacao?.idAnexo
                    );
                  }
                }

                if (!table) {
                  setLoadingPainel(true);
                } else {
                  if (fetchFunc) {
                    fetchFunc();
                  } else {
                    atualizarDados(true);
                  }
                }

                setLoadingCadastro && setLoadingCadastro(true);
                setLoadingHistorico && setLoadingHistorico(true);
                handleGetCriancaReload && handleGetCriancaReload();
                setMovimentacaoData({});
                setMovimentos({
                  options: [],
                  isLoading: false,
                });
                setMovimentacaoEditar(false);
                setAnexoGuiaEditado(false);
                setDisabledMPTJ(false);
                setDisabledPPCAAM(false);

                if (tableCrianca) {
                  history.push(`/crianca/${idCrianca}`);
                }
                Swal.fire({
                  title: "Sucesso!",
                  text: "Registro cadastrado com sucesso!",
                  icon: "success",
                  confirmButtonText: "Continuar",
                  confirmButtonColor: "#169499",
                }).then((result) => {
                  if (
                    valueMovimentos &&
                    (valueMovimentos?.id === 4 || valueMovimentos?.id === 2) &&
                    (roleKeycloack?.includes(
                      criancaFunc.visualizarTudoAcolhimento
                    ) ||
                      roleKeycloack?.includes(
                        criancaFunc.visualizarTudoTutelar
                      ))
                  ) {
                    history.push(`/crianca/${idCrianca}`);
                  }
                });
              })
              .catch((error) => {
                console.log(error);
                Swal.fire({
                  title: "Atenção!",
                  html: error.response.data.message
                    ? error.response.data.message
                    : "",
                  icon: "warning",
                  confirmButtonText: "Fechar",
                  confirmButtonColor: "#169499",
                });
              });
          }
        }
        ["6", "7", "38", "39", "40"].includes(idAnexoParam) ||
          (["5"].includes(idAba) && history.replace(location.pathname));
      } catch (error) {
        console.log(error);
        Swal.fire({
          title: "Atenção!",
          text: error.response.data.message ? error.response.data.message : "",
          icon: "warning",
          confirmButtonText: "Fechar",
          confirmButtonColor: "#169499",
        });
      }
      actions.setSubmitting(false);
    }, 2000);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        Swal.fire({
          title: "Atenção!",
          text: "Deseja cancelar a operação?",
          icon: "error",
          showCancelButton: true,
          confirmButtonColor: "#169499",
          cancelButtonColor: "#169499",
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
        }).then((result) => {
          if (result.isConfirmed) {
            onClose();
            setMovimentacaoData({});
            setMovimentacaoDataAnterior({});
            setMovimentacaoDataPosterior({});
            setMovimentacaoEditar(false);
            setDisabledMPTJ(false);
            setDisabledPPCAAM(false);
            setMesmaFamilia(false);
            setAnexoGuiaEditado(false);
            setAnexoGuiaEditadoTermoGuarda(false);
            setMovimentos({ options: [], isLoading: false });
            setValueMovimentos("");
            setTipoServico("");
            setTipoServicoFinal("");
            setCriancaCPFValid(false);
            setInvalidCPF(false);
            if (!movimentoDefault) {
              setValueMovimentos("");
              setValueMovimentosFinal("");
            }
          }
        });
      }}
      isCentered
      scrollBehavior={shouldScrollInside ? "inside" : "outside"}
      size="7xl"
    >
      <ModalOverlay />
      <ModalContent
        m={"auto"}
        p={{ base: "5px", sm: "15px", md: "25px" }}
        w={{ base: "60%" }}
        bgColor="#FFF"
        ref={modalContentRef}
      >
        <ModalHeader
          p="0px"
          fontWeight={700}
          fontSize="14px"
          lineHeight="19.6px"
          color="#169499"
        >
          {`${
            intercalada
              ? "cadastrar movimento intercalado"
              : `${
                  movimentacaoData && movimentacaoEditar
                    ? "editar"
                    : "cadastrar"
                } movimentação`
          }`.toUpperCase()}
        </ModalHeader>
        <ModalBody p="0px" mt="25px" minH={{ base: "0px" }} pl="1px">
          <Flex flexDir="column" alignItems="center" w="100%">
            <Formik
              onSubmit={(values, actions) => {
                if (
                  values?.idServicoAcolhimento?.id !==
                    movimentacaoData?.servicoAcolhimento?.id &&
                  movimentacaoEditar &&
                  data?.length > 1 &&
                  !!movimentacaoDataPosterior
                ) {
                  Swal.fire({
                    title: "Atenção!",
                    text: "A alteração do Serviço de Acolhimento implicará na exclusão/alteração de movimentos subsequentes. Deseja continuar?",
                    icon: "error",
                    showCancelButton: true,
                    confirmButtonColor: "#169499",
                    cancelButtonColor: "#169499",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      handleSubmit(values, actions);
                    } else {
                      actions.setSubmitting(false);
                    }
                  });
                } else {
                  handleSubmit(values, actions);
                }
              }}
              enableReinitialize
              validationSchema={
                valueMovimentos?.classificacao === "M" ||
                valueMovimentosFinal?.classificacao === "M"
                  ? schemaMotivo
                  : valueMovimentos?.id === 1 ||
                    valueMovimentos?.id === 6 ||
                    valueMovimentosFinal?.id === 1 ||
                    valueMovimentosFinal?.id === 6
                  ? schemaMotivo
                  : movimentoDefault
                  ? schemaMotivo
                  : schemaJustificativa
              }
              initialValues={initialValues}
            >
              {(props) => (
                <>
                  <Form
                    ref={formRef}
                    style={{ width: "100%" }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        props.handleSubmit();
                      }
                    }}
                  >
                    <Flex flexDirection="column">
                      <FocusErrorData />
                      <FocusError />
                      <FocusErrorDate />
                      <UpdateScrollBehavior values={props.values} />
                      <Grid
                        mt="15px"
                        templateColumns="repeat(5, 1fr) 1fr"
                        gap="25px"
                        rowGap="20px"
                      >
                        <GridItem
                          colSpan={
                            !valueMovimentos
                              ? { base: 8, md: 3 }
                              : { base: 8, md: 8, lg: 4, xl: 5 }
                          }
                        >
                          <CustomSelectWField
                            fieldName="idMovimento"
                            label={
                              intercalada ? "Movimento Inicial*" : "Movimento*"
                            }
                            getOptionLabel={(option) => option.descricao}
                            getOptionValue={(option) => option.id}
                            options={movimentos.options}
                            placeholder={"Selecione o Movimento"}
                            isDisabled={
                              disabledMPTJ ||
                              disabledPPCAAM ||
                              (movimentos?.options?.length === 1 &&
                                movimentacaoEditar)
                            }
                            onChange={(value) => {
                              props.setFieldValue("idMovimento", value);
                              setValueMovimentos(value ? value : "");
                              setError("");
                              props.setFieldValue("idMotivoSituacao", "");
                              props.setFieldValue("anexoGuia", "");
                              props.setFieldValue("idJustificativa", "");
                              props.setFieldValue(
                                "existeNovaGuiaAcolhimento",
                                null
                              );

                              if (
                                (value?.id === 1 || value?.id === 3) &&
                                movimentacaoEditar
                              ) {
                                props.setFieldValue("numeroGuia", "");
                                props.setFieldValue("originalAnexoGuia", "");
                                setAnexoGuiaEditado(true);
                              }

                              setValueExiste("");
                            }}
                            onFocus={() => handleGetMovimentos("inicial")}
                          />
                        </GridItem>

                        {valueMovimentos && (
                          <>
                            <GridItem
                              colSpan={{
                                base: 8,
                                md: 8,
                                lg: 4,
                                xl: 3,
                              }}
                            >
                              <CustomDatepickerWField
                                fieldName="dataMovimentacao"
                                label="Data*"
                                isDisabled={disabledMPTJ || disabledPPCAAM}
                                placeholder="DD/MM/AAAA"
                                maxDate={new Date()}
                                blockDate={true}
                              />
                              {dataFutura &&
                                props?.values?.dataMovimentacao && (
                                  <Text
                                    mt="8px"
                                    color="#E53E3E"
                                    fontSize="sm"
                                    lineHeight={"normal"}
                                  >
                                    A data informada não pode ser uma data
                                    futura!
                                  </Text>
                                )}

                              {dataAnterior &&
                                props?.values?.dataMovimentacao &&
                                props?.values?.dataMovimentacao.length === 10 &&
                                !intercalada && (
                                  <Text
                                    mt="8px"
                                    color="#E53E3E"
                                    fontSize="sm"
                                    lineHeight={"normal"}
                                  >
                                    A data da movimentação não pode ser anterior
                                    à última movimentação!
                                  </Text>
                                )}

                              {dataPosterior &&
                                !dataFutura &&
                                props?.values?.dataMovimentacao &&
                                props?.values?.dataMovimentacao.length === 10 &&
                                !intercalada && (
                                  <Text
                                    mt="8px"
                                    color="#E53E3E"
                                    fontSize="sm"
                                    lineHeight={"normal"}
                                  >
                                    Data da movimentação não pode ser maior que
                                    a data da movimentação posterior
                                  </Text>
                                )}

                              {dataApadrinhamentoPosterior &&
                                !dataFutura &&
                                props?.values?.dataMovimentacao &&
                                props?.values?.dataMovimentacao.length === 10 &&
                                !intercalada && (
                                  <Text
                                    mt="8px"
                                    color="#E53E3E"
                                    fontSize="sm"
                                    lineHeight={"normal"}
                                  >
                                    A data do primeiro acolhimento não pode ser
                                    posterior a data do início de um
                                    apadrinhamento
                                  </Text>
                                )}
                            </GridItem>

                            {((valueMovimentos?.classificacao === "M" &&
                              valueMovimentos?.id !== 4) ||
                              !valueMovimentos?.classificacao) &&
                              valueMovimentos?.id !== 6 && (
                                <GridItem colSpan={8}>
                                  <CustomSelectWField
                                    fieldName="idServicoAcolhimento"
                                    label="Serviço de Acolhimento*"
                                    placeholder="Selecione o Serviço de Acolhimento"
                                    getOptionLabel={(option) =>
                                      option?.pessoaJuridica?.nomeFantasia ||
                                      option?.nomeFantasia
                                    }
                                    getOptionValue={(option) => option.id}
                                    isLoading={servicos.isLoading}
                                    options={servicos.options}
                                    isDisabled={
                                      (movimentacaoData &&
                                        movimentacaoEditar &&
                                        roleKeycloack?.includes(
                                          criancaFunc.visualizarTudoAcolhimento
                                        )) ||
                                      disabledMPTJ ||
                                      disabledPPCAAM
                                    }
                                    onChange={(value) => {
                                      props.setFieldValue(
                                        "idServicoAcolhimento",
                                        value
                                      );
                                      if (movimentacaoEditar) {
                                        setInitialValues({
                                          ...initialValues,
                                          idServicoAcolhimento: value
                                            ? value
                                            : "",
                                        });

                                        if (
                                          movimentacaoData?.servicoAcolhimento
                                            ?.id !== value?.id
                                        ) {
                                          props.setFieldValue(
                                            "cpfFamiliaAcolhedora",
                                            ""
                                          );
                                          props.setFieldValue(
                                            "nomeFamiliaAcolhedora",
                                            ""
                                          );
                                          props.setFieldValue(
                                            "dataNascimentoFamiliaAcolhedora",
                                            ""
                                          );
                                          props.setFieldValue(
                                            "dataValidadeTermoGuarda",
                                            ""
                                          );
                                          props.setFieldValue(
                                            "idGeneroFamiliaAcolhedora",
                                            ""
                                          );
                                          setInitialValues({
                                            ...initialValues,
                                            idServicoAcolhimento: value
                                              ? value
                                              : "",
                                            cpfFamiliaAcolhedora: "",
                                            nomeFamiliaAcolhedora: "",
                                            dataNascimentoFamiliaAcolhedora: "",
                                            idGeneroFamiliaAcolhedora: "",
                                            idBairroFamiliaAcolhedora: "",
                                            dataValidadeTermoGuarda: "",
                                            anexoTermoGuardaFamiliaAcolhedora:
                                              null,
                                            originalAnexoTermoGuarda: null,
                                          });
                                        }
                                      }

                                      setTipoServico(value ? value : "");
                                      props.setFieldValue(
                                        "idBairroFamiliaAcolhedora",
                                        null
                                      );
                                    }}
                                    onFocus={
                                      servicos.options.length === 0
                                        ? () => handleGetServicos("inicial")
                                        : null
                                    }
                                  />
                                </GridItem>
                              )}
                            {(valueMovimentos?.classificacao === "M" ||
                              (valueMovimentos?.id !== 1 &&
                                valueMovimentos?.id !== 6 &&
                                movimentoDefault)) && (
                              <GridItem colSpan={8}>
                                <CustomSelectWField
                                  fieldName="idMotivoSituacao"
                                  label="Motivo*"
                                  placeholder="Selecione o motivo"
                                  getOptionLabel={(option) => option.descricao}
                                  getOptionValue={(option) => option.id}
                                  options={motivos.options}
                                  isDisabled={disabledMPTJ || disabledPPCAAM}
                                  onChange={(value) => {
                                    setSelectedOption(value ? value : "");
                                    if (!!value) {
                                      setIsConfirmationModalOpen(true);
                                    } else {
                                      props.setFieldValue(
                                        "idMotivoSituacao",
                                        value ? value : ""
                                      );
                                    }
                                  }}
                                  onFocus={() =>
                                    handleGetMotivos(
                                      props.values.dataMovimentacao
                                    )
                                  }
                                />
                              </GridItem>
                            )}
                            {valueMovimentos?.id === 1 && (
                              <GridItem
                                colSpan={{
                                  base: 8,
                                  sm: 8,
                                  md: 8,
                                  lg: 8,
                                  xl:
                                    valueExiste ||
                                    props?.values?.existeNovaGuiaAcolhimento
                                      ? 2
                                      : 3,
                                }}
                              >
                                <CustomSelectWField
                                  fieldName="existeNovaGuiaAcolhimento"
                                  label="Há Nova Guia de Acolhimento?*"
                                  placeholder="Selecione se há Nova Guia de Acolhimento"
                                  getOptionLabel={(option) => option.descricao}
                                  getOptionValue={(option) => option.id}
                                  options={existeNova.options}
                                  isDisabled={disabledPPCAAM}
                                  onChange={(value) => {
                                    props.setFieldValue(
                                      "existeNovaGuiaAcolhimento",
                                      value ? value : ""
                                    );
                                    setValueExiste(value ? value : "");
                                  }}
                                  onFocus={handleGetExistehaNovaGuiaAcolhimento}
                                  normal
                                />
                              </GridItem>
                            )}

                            {valueMovimentos?.id === 1 &&
                              (valueExiste?.id === 1 ||
                                props?.values?.existeNovaGuiaAcolhimento) && (
                                <>
                                  <GridItem
                                    colSpan={{ base: 8, md: 3, lg: 4, xl: 2 }}
                                  >
                                    <CustomInputWField
                                      maxLength={16}
                                      fieldName="numeroGuia"
                                      label={`Número da Guia ${
                                        valueExiste?.id === 1 ||
                                        props?.values
                                          ?.existeNovaGuiaAcolhimento === 1 ||
                                        props.values.anexoGuia ||
                                        (props.values.originalAnexoGuia &&
                                          !anexoGuiaEditado)
                                          ? "*"
                                          : ""
                                      }`}
                                      onChange={(e) =>
                                        props.setFieldValue(
                                          "numeroGuia",
                                          e.target.value
                                            ? mascaraNumeroGuia(e.target.value)
                                            : ""
                                        )
                                      }
                                      isDisabled={disabledPPCAAM}
                                      placeholder="Informe o número"
                                    />
                                  </GridItem>
                                  <GridItem
                                    colSpan={{ base: 8, md: 3, lg: 3, xl: 2 }}
                                  >
                                    {anexoGuiaEditado ||
                                    !props.values.originalAnexoGuia ? (
                                      <Flex>
                                        <CustomDropzone
                                          whiteSpace={true}
                                          width={"180px"}
                                          formProps={props}
                                          title="Anexar Guia"
                                          fieldName="anexoGuia"
                                          setAnexoNaoEditado={
                                            props.values.originalAnexoGuia
                                              ? () => {
                                                  setAnexoGuiaEditado(true);
                                                  props.setFieldValue(
                                                    "originalAnexoGuia",
                                                    null
                                                  );
                                                }
                                              : null
                                          }
                                          height="42px"
                                          titleText="Informe o número da guia"
                                          isDisabled={disabledPPCAAM}
                                        />
                                      </Flex>
                                    ) : (
                                      props.values.originalAnexoGuia && (
                                        <FileInformation
                                          label="Anexar Guia"
                                          name={
                                            props.values.originalAnexoGuia
                                              .arquivoNome
                                          }
                                          path={props?.values?.originalAnexoGuia?.path
                                            ?.toString()
                                            .split("/")
                                            .pop()}
                                          setAnexoEditado={() => {
                                            setAnexoGuiaEditado(true);
                                          }}
                                          isVisualizacao={false}
                                          height="42px"
                                          width={"216px"}
                                          isDisabled={disabledPPCAAM}
                                        />
                                      )
                                    )}
                                  </GridItem>
                                </>
                              )}

                            {((valueMovimentos && valueMovimentos.id === 3) ||
                              props?.values?.idMovimento?.id === 3) &&
                              props.values.idMotivoSituacao &&
                              props.values.idMotivoSituacao.riscoVida ===
                                "S" && (
                                <>
                                  <GridItem
                                    colSpan={{ base: 3, sm: 3, lg: 3 }}
                                    position={"relative"}
                                    w={"230px"}
                                  >
                                    <CustomSelectWField
                                      fieldName="incluidoProgramaPPCAAM"
                                      label="Incluído no Programa PPCAAM?*"
                                      placeholder="Selecione"
                                      getOptionLabel={(option) => option.label}
                                      getOptionValue={(option) => option.value}
                                      isLoading={motivos.isLoading}
                                      isDisabled={disabledMPTJ}
                                      options={[
                                        { label: "Sim", value: "S" },
                                        { label: "Não", value: "N" },
                                      ]}
                                      onChange={(value) => {
                                        props.setFieldValue(
                                          "incluidoProgramaPPCAAM",
                                          value ? value : ""
                                        );
                                      }}
                                      limitado={true}
                                    />
                                    <Tooltip
                                      label={
                                        "O Programa de Proteção a Crianças e Adolescentes Ameaçados de Morte - PPCAAM, consiste em uma política de proteção à vida de crianças e adolescentes em ameaça iminente de morte."
                                      }
                                      fontSize="md"
                                      textAlign={"justify"}
                                    >
                                      <span
                                        className="hint-tooltip"
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: "215px",
                                        }}
                                      >
                                        <Icon
                                          aria-label="Aviso de pendente"
                                          color="#6B6C71"
                                          as={IoHelpCircle}
                                          boxSize={{ base: "20px" }}
                                        />
                                      </span>
                                    </Tooltip>
                                  </GridItem>
                                  <GridItem
                                    colSpan={{ base: 3, sm: 3, lg: 5 }}
                                  />
                                </>
                              )}

                            {(valueMovimentos?.classificacao === "M" ||
                              !valueMovimentos?.classificacao) &&
                              valueMovimentos?.id !== 1 &&
                              valueMovimentos?.id !== 6 && (
                                <GridItem colSpan={{ base: 8, md: 2 }}>
                                  <CustomInputWField
                                    maxLength={16}
                                    fieldName="numeroGuia"
                                    onChange={(e) =>
                                      props.setFieldValue(
                                        "numeroGuia",
                                        e.target.value
                                          ? mascaraNumeroGuia(e.target.value)
                                          : ""
                                      )
                                    }
                                    label={`Número da Guia ${
                                      props.values.anexoGuia ||
                                      (props.values.originalAnexoGuia &&
                                        !anexoGuiaEditado)
                                        ? "*"
                                        : ""
                                    }`}
                                    isDisabled={disabledPPCAAM}
                                    placeholder="Informe o número"
                                  />
                                </GridItem>
                              )}
                            {(valueMovimentos?.classificacao === "J" ||
                              valueMovimentos?.id === 6) && (
                              <GridItem colSpan={8}>
                                <CustomSelectWField
                                  fieldName="idJustificativa"
                                  label="Justificativa*"
                                  placeholder="Selecione a Justificativa"
                                  getOptionLabel={(option) => option.descricao}
                                  getOptionValue={(option) => option.id}
                                  options={justificativa.options}
                                  isDisabled={disabledMPTJ || disabledPPCAAM}
                                  onChange={(value) => {
                                    props.setFieldValue(
                                      "idJustificativa",
                                      value
                                    );
                                    setJustificativaId(value?.id);
                                  }}
                                  onFocus={() =>
                                    handleGetJustificativa("inicial")
                                  }
                                />
                              </GridItem>
                            )}

                            {props?.values?.idJustificativa?.id === 2 &&
                              props?.values?.idMovimento?.id === 5 && (
                                <GridItem colSpan={{ base: 8, md: 4 }}>
                                  {anexoGuiaEditado ||
                                  !props.values.originalAnexoGuia ? (
                                    <Flex>
                                      <CustomDropzone
                                        whiteSpace={true}
                                        formProps={props}
                                        title="Anexar Decisão de Manutenção do Acolhimento (Maioridade)"
                                        fieldName="anexoGuia"
                                        setAnexoNaoEditado={
                                          props.values.originalAnexoGuia
                                            ? () => {
                                                setAnexoGuiaEditado(true);
                                                props.setFieldValue(
                                                  "originalAnexoGuia",
                                                  null
                                                );
                                              }
                                            : null
                                        }
                                        height="42px"
                                        titleText="Informe o número da guia"
                                        isDisabled={disabledPPCAAM}
                                      />
                                    </Flex>
                                  ) : (
                                    props.values.originalAnexoGuia && (
                                      <FileInformation
                                        label="Anexar Decisão de Manutenção do Acolhimento (Maioridade)"
                                        name={
                                          props.values.originalAnexoGuia
                                            .arquivoNome
                                        }
                                        path={props?.values?.originalAnexoGuia?.path
                                          ?.toString()
                                          .split("/")
                                          .pop()}
                                        setAnexoEditado={() => {
                                          setAnexoGuiaEditado(true);
                                        }}
                                        isVisualizacao={false}
                                        height="42px"
                                        width={"216px"}
                                        isDisabled={disabledPPCAAM}
                                      />
                                    )
                                  )}
                                </GridItem>
                              )}
                            {(valueMovimentos?.classificacao === "M" ||
                              (!valueMovimentos?.classificacao &&
                                valueMovimentos?.id !== 1 &&
                                valueMovimentos?.id !== 6)) && (
                              <GridItem colSpan={{ base: 8, md: 5 }}>
                                {anexoGuiaEditado ||
                                !props.values.originalAnexoGuia ? (
                                  <Flex>
                                    <CustomDropzone
                                      whiteSpace={true}
                                      width={"216px"}
                                      formProps={props}
                                      title="Anexar Guia"
                                      fieldName="anexoGuia"
                                      setAnexoNaoEditado={
                                        props.values.originalAnexoGuia
                                          ? () => {
                                              setAnexoGuiaEditado(true);
                                              props.setFieldValue(
                                                "originalAnexoGuia",
                                                null
                                              );
                                            }
                                          : null
                                      }
                                      height="42px"
                                      titleText="Informe o número da guia"
                                      isDisabled={disabledPPCAAM}
                                    />
                                  </Flex>
                                ) : (
                                  props.values.originalAnexoGuia && (
                                    <FileInformation
                                      label="Anexar Guia"
                                      name={
                                        props.values.originalAnexoGuia
                                          .arquivoNome
                                      }
                                      path={props?.values?.originalAnexoGuia?.path
                                        ?.toString()
                                        .split("/")
                                        .pop()}
                                      setAnexoEditado={() => {
                                        setAnexoGuiaEditado(true);
                                      }}
                                      isVisualizacao={false}
                                      height="42px"
                                      width={"216px"}
                                      isDisabled={disabledPPCAAM}
                                    />
                                  )
                                )}
                              </GridItem>
                            )}
                            {!valueMovimentos?.classificacao &&
                              valueMovimentos?.id !== 1 &&
                              valueMovimentos?.id !== 6 &&
                              !movimentoDefault && (
                                <GridItem colSpan={8}>
                                  <CustomSelectWField
                                    fieldName="idMotivoSituacao"
                                    label="Motivo*"
                                    placeholder="Selecione o motivo"
                                    getOptionLabel={(option) =>
                                      option.descricao
                                    }
                                    getOptionValue={(option) => option.id}
                                    options={motivos.options}
                                    isDisabled={disabledMPTJ || disabledPPCAAM}
                                    onChange={(value) => {
                                      setSelectedOption(value ? value : "");
                                      if (!!value) {
                                        setIsConfirmationModalOpen(true);
                                      } else {
                                        props.setFieldValue(
                                          "idMotivoSituacao",
                                          value ? value : ""
                                        );
                                      }
                                    }}
                                    onFocus={() =>
                                      handleGetMotivos(
                                        props.values.dataMovimentacao
                                      )
                                    }
                                  />
                                </GridItem>
                              )}

                            <GridItem colSpan={8}>
                              <Field name="informacoesComplementares">
                                {({ field, form }) => (
                                  <Flex flexDir="column" position="relative">
                                    <FormControl
                                      isInvalid={
                                        form.errors.informacoesComplementares &&
                                        form.touched.informacoesComplementares
                                      }
                                    >
                                      <FormLabel
                                        color="#5F6377"
                                        fontWeight="500"
                                        fontSize="14px"
                                        lineHeight="19.6px"
                                        htmlFor="informacoesComplementares"
                                      >
                                        {`Informações Complementares${
                                          (justificativaId === 6 &&
                                            valueMovimentos?.id === 2) ||
                                          (justificativaId === 10 &&
                                            valueMovimentos?.id === 6)
                                            ? "*"
                                            : ""
                                        }`}
                                      </FormLabel>
                                      <Textarea
                                        {...field}
                                        name="informacoesComplementares"
                                        id="informacoesComplementares"
                                        backgroundColor="#fff"
                                        autoComplete="off"
                                        border="1px solid #D7D8DE"
                                        placeholder="Informe as Informações Complementares"
                                        maxLength={150}
                                        isDisabled={
                                          disabledMPTJ || disabledPPCAAM
                                        }
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (value.length <= 150) {
                                            form.setFieldValue(
                                              "informacoesComplementares",
                                              value
                                            );
                                          }
                                        }}
                                      />
                                      <Text
                                        zIndex={1}
                                        fontSize="sm"
                                        position="absolute"
                                        bottom="5px"
                                        right="15px"
                                        color={
                                          field.value.length === 150
                                            ? "red"
                                            : "gray"
                                        }
                                      >
                                        {field.value.length}/150
                                      </Text>
                                      <FormErrorMessage>
                                        {form.errors.informacoesComplementares}
                                      </FormErrorMessage>
                                    </FormControl>
                                  </Flex>
                                )}
                              </Field>
                            </GridItem>
                          </>
                        )}
                        {valueMovimentosFinal && error && (
                          <GridItem colSpan={6}>
                            <Text color="#e53e3e" fontSize="14px">
                              {error}
                            </Text>
                          </GridItem>
                        )}
                      </Grid>

                      {(tipoServico
                        ? tipoServico?.tipoServicoAcolhimento?.regime ===
                            "SAF" ||
                          tipoServico?.servicoAcolhimento?.regime === "SAF" ||
                          (valueMovimentos?.id === 6 &&
                            tipoServico?.servicoAcolhimento?.regime === "SAF" &&
                            ((valueMovimentos.options
                              ? [1, 3, 6].includes(
                                  valueMovimentos.options[0]?.id
                                )
                              : false) ||
                              [1, 3, 6].includes(valueMovimentos?.id)))
                        : (data[0]?.servicoAcolhimento?.regime === "SAF" &&
                            valueMovimentos?.id === 6) ||
                          (props?.values?.idServicoAcolhimento?.regime ===
                            "SAF" &&
                            [1, 3, 6].includes(valueMovimentos?.id) &&
                            movimentacaoEditar)) &&
                        props.values.idMovimento && (
                          <FamiliaAcolhedora
                            movimentacaoEditar={movimentacaoEditar}
                            setMesmaFamilia={setMesmaFamilia}
                            props={props}
                            id={idCrianca}
                            idServicoAcolhimento={
                              valueMovimentos?.id === 6
                                ? tipoServico?.servicoAcolhimento?.id ||
                                  data[0]?.servicoAcolhimento?.id
                                : tipoServico?.id
                            }
                            invalidCPF={invalidCPF}
                            criancaCPFValid={criancaCPFValid}
                            messageValid={messageValid}
                            setMessageValid={setMessageValid}
                            disabledMPTJ={disabledMPTJ || disabledPPCAAM}
                            anexoGuiaEditadoTermoGuarda={
                              anexoGuiaEditadoTermoGuarda
                            }
                            setAnexoGuiaEditadoTermoGuarda={
                              setAnexoGuiaEditadoTermoGuarda
                            }
                            dataNascimentoFuturaFamilia={
                              dataNascimentoFuturaFamilia
                            }
                            movimentacaoData={movimentacaoData}
                          />
                        )}

                      {valueMovimentos && intercalada && (
                        <Grid
                          mt="15px"
                          templateColumns="repeat(5, 1fr) 1fr"
                          gap="25px"
                          rowGap="20px"
                        >
                          <GridItem
                            colSpan={
                              !valueMovimentosFinal
                                ? { base: 8, md: 2 }
                                : { base: 8, md: 8, lg: 4, xl: 5 }
                            }
                          >
                            <CustomSelectWField
                              fieldName="idMovimentoFinal"
                              label={"Movimento Final*"}
                              getOptionLabel={(option) => option.descricao}
                              getOptionValue={(option) => option.id}
                              options={movimentosFinais.options}
                              placeholder={"Selecione o Movimento Final"}
                              onChange={(value) => {
                                props.setFieldValue("idMovimentoFinal", value);
                                setValueMovimentosFinal(value ? value : "");
                                setError("");
                                props.setFieldValue(
                                  "idMotivoSituacaoFinal",
                                  ""
                                );
                                props.setFieldValue("anexoGuiaFinal", "");
                                props.setFieldValue("idJustificativaFinal", "");
                                props.setFieldValue(
                                  "existeNovaGuiaAcolhimentoFinal",
                                  null
                                );
                                setValueExisteFinal("");
                              }}
                              onFocus={() => handleGetMovimentos("final")}
                            />
                          </GridItem>
                          {valueMovimentosFinal && (
                            <>
                              <GridItem
                                colSpan={{
                                  base: 8,
                                  md: 8,
                                  lg: 4,
                                  xl: 3,
                                }}
                              >
                                <CustomDatepickerWField
                                  fieldName="dataMovimentacaoFinal"
                                  label="Data*"
                                  placeholder="DD/MM/AAAA"
                                  maxDate={new Date()}
                                  blockDate={true}
                                />
                                {dataFuturaFinal &&
                                  props.values.dataMovimentacaoFinal && (
                                    <Text
                                      mt="8px"
                                      color="#E53E3E"
                                      fontSize="sm"
                                      lineHeight={"normal"}
                                    >
                                      A data informada não pode ser uma data
                                      futura!
                                    </Text>
                                  )}
                              </GridItem>

                              {((valueMovimentosFinal?.classificacao === "M" &&
                                valueMovimentosFinal?.id !== 4) ||
                                !valueMovimentosFinal?.classificacao) &&
                                valueMovimentosFinal?.id !== 6 && (
                                  <GridItem colSpan={8}>
                                    <CustomSelectWField
                                      fieldName="idServicoAcolhimentoFinal"
                                      label="Serviço de Acolhimento*"
                                      placeholder="Selecione o Serviço de Acolhimento"
                                      getOptionLabel={(option) =>
                                        option?.pessoaJuridica?.nomeFantasia
                                      }
                                      getOptionValue={(option) => option.id}
                                      isLoading={servicosFinal.isLoading}
                                      options={servicosFinal.options}
                                      onChange={(value) => {
                                        props.setFieldValue(
                                          "idServicoAcolhimentoFinal",
                                          value
                                        );
                                        setTipoServicoFinal(value);
                                      }}
                                      onFocus={
                                        servicosFinal.options.length === 0
                                          ? () => handleGetServicos("final")
                                          : null
                                      }
                                    />
                                  </GridItem>
                                )}
                              {(valueMovimentosFinal?.classificacao === "M" ||
                                movimentoDefault) && (
                                <GridItem colSpan={8}>
                                  <CustomSelectWField
                                    fieldName="idMotivoSituacaoFinal"
                                    label="Motivo*"
                                    placeholder="Selecione o motivo"
                                    getOptionLabel={(option) =>
                                      option.descricao
                                    }
                                    getOptionValue={(option) => option.id}
                                    options={motivosFinal.options}
                                    onChange={(value) => {
                                      setSelectedOptionFinal(
                                        value ? value : ""
                                      );

                                      if (!!value) {
                                        setIsConfirmationModalOpenFinal(true);
                                      } else {
                                        props.setFieldValue(
                                          "idMotivoSituacaoFinal",
                                          value ? value : ""
                                        );
                                      }
                                    }}
                                    onFocus={() =>
                                      handleGetMotivos(
                                        props.values.dataMovimentacaoFinal
                                      )
                                    }
                                  />
                                </GridItem>
                              )}

                              {valueMovimentosFinal?.id === 1 && (
                                <GridItem
                                  colSpan={{
                                    base: 8,
                                    sm: 8,
                                    md: 8,
                                    lg: 8,
                                    xl: valueExisteFinal ? 2 : 3,
                                  }}
                                >
                                  <CustomSelectWField
                                    fieldName="existeNovaGuiaAcolhimentoFinal"
                                    label="Há Nova Guia de Acolhimento?*"
                                    placeholder="Selecione se há Nova Guia de Acolhimento"
                                    getOptionLabel={(option) =>
                                      option.descricao
                                    }
                                    getOptionValue={(option) => option.id}
                                    options={existeNovaFinal.options}
                                    onChange={(value) => {
                                      props.setFieldValue(
                                        "existeNovaGuiaAcolhimentoFinal",
                                        value ? value : ""
                                      );
                                      setValueExisteFinal(value ? value : "");
                                    }}
                                    onFocus={
                                      handleGetExistehaNovaGuiaAcolhimento
                                    }
                                    normal
                                  />
                                </GridItem>
                              )}

                              {valueMovimentosFinal?.id === 1 &&
                                valueExisteFinal?.id === 1 && (
                                  <>
                                    <GridItem
                                      colSpan={{
                                        base: 8,
                                        md: 3,
                                        lg: 4,
                                        xl: 2,
                                      }}
                                    >
                                      <CustomInputWField
                                        maxLength={15}
                                        fieldName="numeroGuiaFinal"
                                        label={`Número da Guia ${
                                          valueExisteFinal?.id === 1 ||
                                          props.values.anexoGuiaFinal
                                            ? "*"
                                            : ""
                                        }`}
                                        onChange={(e) =>
                                          props.setFieldValue(
                                            "numeroGuiaFinal",
                                            e.target.value
                                              ? mascaraNumeroGuia(
                                                  e.target.value
                                                )
                                              : ""
                                          )
                                        }
                                        placeholder="Informe o número"
                                      />
                                    </GridItem>
                                    <GridItem
                                      colSpan={{
                                        base: 8,
                                        md: 3,
                                        lg: 3,
                                        xl: 2,
                                      }}
                                    >
                                      <Flex>
                                        <CustomDropzone
                                          width={"180px"}
                                          formProps={props}
                                          title="Anexar Guia"
                                          fieldName="anexoGuiaFinal"
                                          height="42px"
                                          titleText="Informe o número da guia"
                                        />
                                      </Flex>
                                    </GridItem>
                                  </>
                                )}
                              {(valueMovimentosFinal?.classificacao === "M" ||
                                !valueMovimentosFinal?.classificacao) &&
                                valueMovimentosFinal?.id !== 1 &&
                                valueMovimentosFinal?.id !== 6 && (
                                  <GridItem colSpan={{ base: 8, md: 3 }}>
                                    <CustomInputWField
                                      maxLength={15}
                                      fieldName="numeroGuiaFinal"
                                      onChange={(e) =>
                                        props.setFieldValue(
                                          "numeroGuiaFinal",
                                          e.target.value
                                            ? mascaraNumeroGuia(e.target.value)
                                            : ""
                                        )
                                      }
                                      label={`Número da Guia ${
                                        props.values.anexoGuiaFinal ? "*" : ""
                                      }`}
                                      placeholder="Informe o número"
                                    />
                                  </GridItem>
                                )}
                              {(valueMovimentosFinal?.classificacao === "J" ||
                                valueMovimentosFinal?.id === 6) && (
                                <GridItem colSpan={8}>
                                  <CustomSelectWField
                                    fieldName="idJustificativaFinal"
                                    label="Justificativa*"
                                    placeholder="Selecione a Justificativa"
                                    getOptionLabel={(option) =>
                                      option.descricao
                                    }
                                    getOptionValue={(option) => option.id}
                                    options={justificativaFinal.options}
                                    onChange={(value) => {
                                      props.setFieldValue(
                                        "idJustificativaFinal",
                                        value
                                      );
                                      setJustificativaIdFinal(value?.id);
                                    }}
                                    onFocus={() =>
                                      handleGetJustificativa("final")
                                    }
                                  />
                                </GridItem>
                              )}

                              {(valueMovimentosFinal?.classificacao === "M" ||
                                (!valueMovimentosFinal?.classificacao &&
                                  valueMovimentosFinal?.id !== 1 &&
                                  valueMovimentosFinal?.id !== 6)) && (
                                <GridItem colSpan={{ base: 8, md: 5 }}>
                                  <Flex>
                                    <CustomDropzone
                                      width={"216px"}
                                      formProps={props}
                                      title="Anexar Guia"
                                      fieldName="anexoGuiaFinal"
                                      height="42px"
                                      titleText="Informe o número da guia"
                                    />
                                  </Flex>
                                </GridItem>
                              )}
                              {!valueMovimentosFinal?.classificacao &&
                                valueMovimentosFinal?.id !== 1 &&
                                valueMovimentosFinal?.id !== 6 &&
                                !movimentoDefault && (
                                  <GridItem colSpan={8}>
                                    <CustomSelectWField
                                      fieldName="idMotivoSituacaoFinal"
                                      label="Motivo*"
                                      placeholder="Selecione o motivo"
                                      getOptionLabel={(option) =>
                                        option.descricao
                                      }
                                      getOptionValue={(option) => option.id}
                                      options={motivosFinal.options}
                                      onChange={(value) => {
                                        props.setFieldValue(
                                          "idMotivoSituacaoFinal",
                                          value ? value : ""
                                        );
                                      }}
                                      onFocus={() =>
                                        handleGetMotivos(
                                          props.values.dataMovimentacaoFinal
                                        )
                                      }
                                    />
                                  </GridItem>
                                )}

                              <GridItem colSpan={8}>
                                <Field name="informacoesComplementaresFinal">
                                  {({ field, form }) => (
                                    <Flex flexDir="column" position="relative">
                                      <FormControl
                                        isInvalid={
                                          form.errors
                                            .informacoesComplementaresFinal &&
                                          form.touched
                                            .informacoesComplementaresFinal
                                        }
                                      >
                                        <FormLabel
                                          color="#5F6377"
                                          fontWeight="500"
                                          fontSize="14px"
                                          lineHeight="19.6px"
                                          htmlFor="informacoesComplementaresFinal"
                                        >
                                          {`Informações Complementares${
                                            (justificativaIdFinal === 6 &&
                                              valueMovimentosFinal?.id === 2) ||
                                            (justificativaIdFinal === 10 &&
                                              valueMovimentosFinal?.id === 6)
                                              ? "*"
                                              : ""
                                          }`}
                                        </FormLabel>
                                        <Textarea
                                          {...field}
                                          name="informacoesComplementaresFinal"
                                          id="informacoesComplementaresFinal"
                                          backgroundColor="#fff"
                                          autoComplete="off"
                                          border="1px solid #D7D8DE"
                                          placeholder="Informe as Informações Complementares"
                                          maxLength={150}
                                          onChange={(e) => {
                                            const value = e.target.value;
                                            if (value.length <= 150) {
                                              form.setFieldValue(
                                                "informacoesComplementaresFinal",
                                                value
                                              );
                                            }
                                          }}
                                        />
                                        <Text
                                          zIndex={1}
                                          fontSize="sm"
                                          position="absolute"
                                          bottom="5px"
                                          right="15px"
                                          color={
                                            field.value.length === 150
                                              ? "red"
                                              : "gray"
                                          }
                                        >
                                          {field.value.length}/150
                                        </Text>
                                        <FormErrorMessage>
                                          {
                                            form.errors
                                              .informacoesComplementaresFinal
                                          }
                                        </FormErrorMessage>
                                      </FormControl>
                                    </Flex>
                                  )}
                                </Field>
                              </GridItem>
                            </>
                          )}
                          {valueMovimentosFinal && error && (
                            <GridItem colSpan={6}>
                              <Text color="#e53e3e" fontSize="14px">
                                {error}
                              </Text>
                            </GridItem>
                          )}
                        </Grid>
                      )}

                      {(tipoServicoFinal
                        ? tipoServicoFinal?.tipoServicoAcolhimento?.regime ===
                            "SAF" ||
                          (valueMovimentosFinal?.id === 6 &&
                            tipoServicoFinal?.servicoAcolhimento?.regime ===
                              "SAF" &&
                            ((valueMovimentosFinal.options
                              ? valueMovimentosFinal.options[0]?.id === 3 ||
                                valueMovimentosFinal.options[0]?.id === 6 ||
                                valueMovimentosFinal.options[0]?.id === 1
                              : false) ||
                              (valueMovimentosFinal
                                ? valueMovimentosFinal?.id === 3 ||
                                  valueMovimentosFinal?.id === 6 ||
                                  valueMovimentosFinal?.id === 1
                                : false)))
                        : data[0]?.servicoAcolhimento?.regime === "SAF" &&
                          valueMovimentosFinal?.id === 6) && (
                        <FamiliaAcolhedora
                          movimentacaoEditar={movimentacaoEditar}
                          setMesmaFamilia={setMesmaFamilia}
                          props={props}
                          id={idCrianca}
                          idServicoAcolhimento={
                            valueMovimentosFinal?.id === 6
                              ? tipoServicoFinal?.servicoAcolhimento?.id
                              : tipoServicoFinal?.id
                          }
                          invalidCPF={invalidCPF}
                          criancaCPFValid={criancaCPFValid}
                          messageValid={messageValid}
                          setMessageValid={setMessageValid}
                          anexoGuiaEditadoTermoGuarda={
                            anexoGuiaEditadoTermoGuarda
                          }
                          setAnexoGuiaEditadoTermoGuarda={
                            setAnexoGuiaEditadoTermoGuarda
                          }
                          dataNascimentoFuturaFamilia={
                            dataNascimentoFuturaFamilia
                          }
                        />
                      )}
                      <SimpleGrid
                        alignSelf="end"
                        mt="20px"
                        columns={valueMovimentos ? 2 : 1}
                        spacing="15px"
                        w={{
                          base: "100%",
                          lg: valueMovimentos ? "40%" : "20%",
                        }}
                      >
                        <Button
                          color="#FFF"
                          backgroundColor="#169499"
                          fontWeight={700}
                          fontSize="15px"
                          lineHeight="21.6px"
                          _hover={{ bg: "#169499" }}
                          onClick={() => {
                            Swal.fire({
                              title: "Atenção!",
                              text: "Deseja cancelar a operação?",
                              icon: "error",
                              showCancelButton: true,
                              confirmButtonColor: "#169499",
                              cancelButtonColor: "#169499",
                              confirmButtonText: "Sim",
                              cancelButtonText: "Não",
                            }).then((result) => {
                              if (result.isConfirmed) {
                                onClose();
                                setMovimentacaoData({});
                                setMovimentacaoDataAnterior({});
                                setMovimentacaoDataPosterior({});
                                setMovimentos({
                                  options: [],
                                  isLoading: false,
                                });
                                setMovimentacaoEditar(false);
                                setDisabledMPTJ(false);
                                setDisabledPPCAAM(false);
                                setMesmaFamilia(false);
                                setAnexoGuiaEditado(false);
                                setAnexoGuiaEditadoTermoGuarda(false);
                                setValueMovimentos("");
                                setTipoServico("");
                                setTipoServicoFinal("");
                                setCriancaCPFValid(false);
                                setInvalidCPF(false);
                                if (!movimentoDefault) {
                                  setValueMovimentos("");
                                  setValueMovimentosFinal("");
                                }
                              }
                            });
                          }}
                        >
                          Cancelar
                        </Button>

                        {valueMovimentos && (
                          <Button
                            type="submit"
                            translate="no"
                            color="#FFF"
                            backgroundColor="#169499"
                            fontWeight={700}
                            fontSize="15px"
                            lineHeight="21.6px"
                            _hover={{ bg: "#169499" }}
                            isLoading={props.isSubmitting}
                          >
                            Salvar
                          </Button>
                        )}
                      </SimpleGrid>
                    </Flex>
                  </Form>
                  <ConfirmationModal
                    isOpen={
                      isConfirmationModalOpen || isConfirmationModalOpenFinal
                    }
                    selectedOption={
                      isConfirmationModalOpen
                        ? selectedOption
                        : isConfirmationModalOpenFinal
                        ? selectedOptionFinal
                        : null
                    }
                    onClose={() => {
                      setIsConfirmationModalOpen(false);
                      setIsConfirmationModalOpenFinal(false);
                    }}
                    onConfirm={() => handleConfirmAction(props)}
                  />
                </>
              )}
            </Formik>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
